const REQUEST_API_LOGIN = 'REQUEST_API_LOGIN';
const REQUEST_API_LOGOUT = 'REQUEST_API_LOGOUT';
const REQUEST_API_LOGOUT_SUCCESS = 'REQUEST_API_LOGOUT_SUCCESS';
const REQUEST_API_LOGIN_SUCCESS = 'REQUEST_API_LOGIN_SUCCESS';
const REQUEST_API_LOGIN_FAILED = 'REQUEST_API_LOGIN_FAILED';

const REQUEST_API_BALANCE = 'REQUEST_API_BALANCE';
const REQUEST_API_BALANCE_SUCCESS = 'REQUEST_API_BALANCE_SUCCESS';
const REQUEST_API_BALANCE_FAILED = 'REQUEST_API_BALANCE_FAILED';
const REQUEST_CLEAR_BALANCE = 'REQUEST_CLEAR_BALANCE';

const REQUEST_API_USERSERVLET = 'REQUEST_API_USERSERVLET';
const REQUEST_API_USERSERVLET_SUCCESS = 'REQUEST_API_USERSERVLET_SUCCESS';
const REQUEST_API_USERSERVLET_FAILED = 'REQUEST_API_USERSERVLET_FAILED';
const REQUEST_CLEAR_USERSERVLET = 'REQUEST_CLEAR_USERSERVLET';

const REQUEST_API_CONTACT_SERVLET = 'REQUEST_API_CONTACT_SERVLET';
const REQUEST_API_CONTACT_SERVLET_SUCCESS = 'REQUEST_API_CONTACT_SERVLET_SUCCESS';
const REQUEST_API_CONTACT_SERVLET_FAILED = 'REQUEST_API_CONTACT_SERVLET_FAILED';
const CLEAR_INFO_CONTACT = 'CLEAR_INFO_CONTACT';
const REQUEST_API_MANAGE_CONTACT_SERVLET = 'REQUEST_API_MANAGE_CONTACT_SERVLET';
const REQUEST_API_MANAGE_CONTACT_SERVLET_SUCCESS = 'REQUEST_API_MANAGE_CONTACT_SERVLET_SUCCESS';
const REQUEST_CLEAR_CONTACT_SERVLET = 'REQUEST_CLEAR_CONTACT_SERVLET';
const REQUEST_CLEAR_CONTACT_SERVLET_SUCCESS = 'REQUEST_CLEAR_CONTACT_SERVLET_SUCCESS';
const REQUEST_API_GET_CONTACT_BELONG_TO = 'REQUEST_API_GET_CONTACT_BELONG_TO';
const REQUEST_API_GET_CONTACT_BELONG_TO_SUCCESS = 'REQUEST_API_GET_CONTACT_BELONG_TO_SUCCESS';

// const REQUEST_FILTER_CONTACT_DETAIL = 'REQUEST_FILTER_CONTACT_DETAIL';
// const REQUEST_FILTER_CONTACT_DETAIL_SUCCESS = 'REQUEST_FILTER_CONTACT_DETAIL_SUCCESS';
// const REQUEST_FILTER_CONTACT_DETAIL_FAILED = 'REQUEST_FILTER_CONTACT_DETAIL_FAILED';
const REQUEST_CLEAR_CONTACT_DETAIL = 'REQUEST_CLEAR_CONTACT_DETAIL';

const REQUEST_API_AUTO_REPLIES_SERVLET = 'REQUEST_API_AUTO_REPLIES_SERVLET';
const REQUEST_API_AUTO_REPLIES_SERVLET_SUCCESS = 'REQUEST_API_AUTO_REPLIES_SERVLET_SUCCESS';
const REQUEST_API_AUTO_REPLIES_SERVLET_FAILED = 'REQUEST_API_AUTO_REPLIES_SERVLET_FAILED';
const REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS =
  'REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS';
const REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_SUCCESS =
  'REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_SUCCESS';
const REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_FAILED =
  'REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_FAILED';
const REQUEST_CLEAR_AUTO_REPLIES_SERVLET = 'REQUEST_CLEAR_AUTO_REPLIES_SERVLET';
const REQUEST_CLEAR_AUTO_REPLIES_SERVLET_SUCCESS = 'REQUEST_CLEAR_AUTO_REPLIES_SERVLET_SUCCESS';

const REQUEST_API_SERVLET = 'REQUEST_API_SERVLET';
const REQUEST_API_SERVLET_SUCCESS = 'REQUEST_API_SERVLET_SUCCESS';
const REQUEST_API_SERVLET_FAILED = 'REQUEST_API_SERVLET_FAILED';
const REQUEST_CLEAR_SERVLET = 'REQUEST_CLEAR_SERVLET';
const REQUEST_REFRESH_SERVLET = 'REQUEST_REFRESH_SERVLET';

const REQUEST_API_INBOX = 'REQUEST_API_INBOX';
const REQUEST_API_INBOX_FILTER = 'REQUEST_API_INBOX_FILTER';
const REQUEST_API_INBOX_FILTER_SUCCESS = 'REQUEST_API_INBOX_FILTER_SUCCESS';

const REQUEST_API_INBOX_LOADMORE = 'REQUEST_API_INBOX_LOADMORE';
const REQUEST_API_INBOX_LOADMORE_SUCCESS = 'REQUEST_API_INBOX_LOADMORE_SUCCESS';

const REQUEST_API_INBOX_SUCCESS = 'REQUEST_API_INBOX_SUCCESS';
const REQUEST_API_INBOX_FAILED = 'REQUEST_API_INBOX_FAILED';

const REQUEST_API_INBOX_DETAIL = 'REQUEST_API_INBOX_DETAIL';
const REQUEST_API_INBOX_DETAIL_SUCCESS = 'REQUEST_API_INBOX_DETAIL_SUCCESS';

const REQUEST_API_INBOX_CHANGE_STAR = 'REQUEST_API_INBOX_CHANGE_STAR';
const REQUEST_API_INBOX_CHANGE_STAR_SUCCESS = 'REQUEST_API_INBOX_CHANGE_STAR_SUCCESS';

const REQUEST_API_EXPORT_INBOX = 'REQUEST_API_EXPORT_INBOX';
const REQUEST_API_EXPORT_INBOX_SUCCESS = 'REQUEST_API_EXPORT_INBOX_SUCCESS';

const REQUEST_API_DELETE = 'REQUEST_API_DELETE';
const REQUEST_API_DELETE_SUCCESS = 'REQUEST_API_DELETE_SUCCESS';
const REQUEST_API_DELETE_ALL = 'REQUEST_API_DELETE_ALL';
const REQUEST_API_DELETE_ALL_SUCCESS = 'REQUEST_API_DELETE_ALL_SUCCESS';
const REQUEST_CLEAR_EXPORT_INBOX = 'REQUEST_CLEAR_EXPORT_INBOX';
const REQUEST_API_DELETE_BY_DATE = 'REQUEST_API_DELETE_BY_DATE';
const REQUEST_API_DELETE_BY_DATE_SUCCESS = 'REQUEST_API_DELETE_BY_DATE_SUCCESS';

const REQUEST_CLEAR_INBOX = 'REQUEST_CLEAR_INBOX';
const REQUEST_CLEAR_DETAIL_INBOX = 'REQUEST_CLEAR_DETAIL_INBOX';

const REQUEST_INBOX_BETA = 'REQUEST_INBOX_BETA';

const REQUEST_SEND_INBOX_SERVLET = 'REQUEST_SEND_INBOX_SERVLET';
const REQUEST_SEND_INBOX_SERVLET_SUCCESS = 'REQUEST_SEND_INBOX_SERVLET_SUCCESS';
const REQUEST_SEND_INBOX_SERVLET_FAILED = 'REQUEST_SEND_INBOX_SERVLET_FAILED';

const REQUEST_SEND_SERVLET = 'REQUEST_SEND_SERVLET';
const REQUEST_SEND_SERVLET_SUCCESS = 'REQUEST_SEND_SERVLET_SUCCESS';
const REQUEST_SEND_SERVLET_FAILED = 'REQUEST_SEND_SERVLET_FAILED';

const REQUEST_SPIN_SERVLET = 'REQUEST_SPIN_SERVLET';
const REQUEST_SPIN_SERVLET_SUCCESS = 'REQUEST_SPIN_SERVLET_SUCCESS';
const REQUEST_SPIN_SERVLET_FAILED = 'REQUEST_SPIN_SERVLET_FAILED';
const REQUEST_CLEAR_SPIN = 'REQUEST_CLEAR_SPIN';

const REQUEST_PREVIEW_SPIN = 'REQUEST_PREVIEW_SPIN';
const REQUEST_PREVIEW_SPIN_SUCCESS = 'REQUEST_PREVIEW_SPIN_SUCCESS';
const REQUEST_PREVIEW_SPIN_FAILED = 'REQUEST_PREVIEW_SPIN_FAILED';
const REQUEST_CLEAR_PREVIEW_SPIN = 'REQUEST_CLEAR_PREVIEW_SPIN';

const REQUEST_AVAILABLE_COUNTRIES = 'REQUEST_AVAILABLE_COUNTRIES';
const REQUEST_AVAILABLE_COUNTRIES_SUCCESS = 'REQUEST_AVAILABLE_COUNTRIES_SUCCESS';
const REQUEST_AVAILABLE_COUNTRIES_FAILED = 'REQUEST_AVAILABLE_COUNTRIES_FAILED';

const REQUEST_LOAD_CONFIG = 'REQUEST_LOAD_CONFIG';
const REQUEST_LOAD_CONFIG_SUCCESS = 'REQUEST_LOAD_CONFIG_SUCCESS';
const REQUEST_LOAD_CONFIG_FAILED = 'REQUEST_LOAD_CONFIG_FAILED';

const REQUEST_MANAGE_USER = 'REQUEST_MANAGE_USER';
const REQUEST_MANAGE_USER_SUCCESS = 'REQUEST_MANAGE_USER_SUCCESS';
const REQUEST_MANAGE_USER_FAILED = 'REQUEST_MANAGE_USER_FAILED';
const REQUEST_CHANGE_USER = 'REQUEST_CHANGE_USER';
const REQUEST_CHANGE_USER_SUCCESS = 'REQUEST_CHANGE_USER_SUCCESS';
const REQUEST_CHANGE_USER_FAILED = 'REQUEST_CHANGE_USER_FAILED';

const REQUEST_HISTORY_BY_ID = 'REQUEST_HISTORY_BY_ID';
const REQUEST_HISTORY_BY_ID_SUCCESS = 'REQUEST_HISTORY_BY_ID_SUCCESS';
const REQUEST_HISTORY_BY_ID_FAILED = 'REQUEST_HISTORY_BY_ID_FAILED';

const REQUEST_MORE_HISTORY = 'REQUEST_MORE_HISTORY';
const REQUEST_MORE_HISTORY_SUCCESS = 'REQUEST_MORE_HISTORY_SUCCESS';
const IS_LAST_HISTORY = 'IS_LAST_HISTORY';
const REQUEST_MORE_HISTORY_FAILED = 'REQUEST_MORE_HISTORY_FAILED';

const REQUEST_PAUSE_LOAD_HISTORY = 'REQUEST_PAUSE_LOAD_HISTORY';
const REQUEST_PAUSE_LOAD_HISTORY_SUCCESS = 'REQUEST_PAUSE_LOAD_HISTORY_SUCCESS';
const REQUEST_PAUSE_LOAD_HISTORY_FAILED = 'REQUEST_PAUSE_LOAD_HISTORY_FAILED';

const REQUEST_ADD_CONTACT = 'REQUEST_ADD_CONTACT';
const REQUEST_ADD_CONTACT_SUCCESS = 'REQUEST_ADD_CONTACT_SUCCESS';
const REQUEST_ADD_CONTACT_FAILED = 'REQUEST_ADD_CONTACT_FAILED';

const REQUEST_REMOVE_CONTACT = 'REQUEST_REMOVE_CONTACT';
const REQUEST_REMOVE_CONTACT_SUCCESS = 'REQUEST_REMOVE_CONTACT_SUCCESS';
const REQUEST_REMOVE_CONTACT_FAILED = 'REQUEST_REMOVE_CONTACT_FAILED';

const REQUEST_CONTINUE_HIST = 'REQUEST_CONTINUE_HIST';
const REQUEST_CONTINUE_HIST_SUCCESS = 'REQUEST_CONTINUE_HIST_SUCCESS';
const REQUEST_CONTINUE_HIST_FAILED = 'REQUEST_CONTINUE_HIST_FAILED';

const REQUEST_MARK_AS_COMPLETED = 'REQUEST_MARK_AS_COMPLETED';
const REQUEST_MARK_AS_COMPLETED_SUCCESS = 'REQUEST_MARK_AS_COMPLETED_SUCCESS';
const REQUEST_MARK_AS_COMPLETED_FAILED = 'REQUEST_MARK_AS_COMPLETED_FAILED';

const REQUEST_UPDATE_MESSAGE_HIST = 'REQUEST_UPDATE_MESSAGE_HIST';
const REQUEST_UPDATE_MESSAGE_HIST_SUCCESS = 'REQUEST_UPDATE_MESSAGE_HIST_SUCCESS';
const REQUEST_UPDATE_MESSAGE_HIST_FAILED = 'REQUEST_UPDATE_MESSAGE_HIST_FAILED';

const REQUEST_GET_EDIT_CONTACT = 'REQUEST_GET_EDIT_CONTACT';
const REQUEST_GET_EDIT_CONTACT_SUCCESS = 'REQUEST_GET_EDIT_CONTACT_SUCCESS';
const REQUEST_GET_EDIT_CONTACT_FAILED = 'REQUEST_GET_EDIT_CONTACT_FAILED';
const REQUEST_CLEAR_EDIT_CONTACT = 'REQUEST_CLEAR_EDIT_CONTACT';

const REQUEST_SCRUB_CONTACT = 'REQUEST_SCRUB_CONTACT';
const REQUEST_SCRUB_CONTACT_SUCCESS = 'REQUEST_SCRUB_CONTACT_SUCCESS';
const REQUEST_SCRUB_CONTACT_FAILED = 'REQUEST_SCRUB_CONTACT_FAILED';

const REQUEST_GETALL_LANDLINE_CHECK = 'REQUEST_GETALL_LANDLINE_CHECK';
const REQUEST_GETALL_LANDLINE_CHECK_SUCCESS = 'REQUEST_GETALL_LANDLINE_CHECK_SUCCESS';
const REQUEST_GETALL_LANDLINE_CHECK_FAILED = 'REQUEST_GETALL_LANDLINE_CHECK_FAILED';

const REQUEST_CHECK_SCRUB = 'REQUEST_CHECK_SCRUB';
const REQUEST_CHECK_SCRUB_SUCCESS = 'REQUEST_CHECK_SCRUB_SUCCESS';
const REQUEST_CHECK_SCRUB_FAILED = 'REQUEST_CHECK_SCRUB_FAILED';
const REQUEST_CHECK_SCRUB_CANCEL = 'REQUEST_CHECK_SCRUB_CANCEL';

const CLEAR_SCRUB_CONTACT = 'CLEAR_SCRUB_CONTACT';

const REQUEST_LANDLINE_CHECK = 'REQUEST_LANDLINE_CHECK';
const REQUEST_LANDLINE_CHECK_SUCCESS = 'REQUEST_LANDLINE_CHECK_SUCCESS';
const REQUEST_LANDLINE_CHECK_FAILED = 'REQUEST_LANDLINE_CHECK_FAILED';

const REQUEST_CANCEL_LANDLINE = 'REQUEST_CANCEL_LANDLINE';
const REQUEST_CANCEL_LANDLINE_SUCCESS = 'REQUEST_CANCEL_LANDLINE_SUCCESS';
const REQUEST_CANCEL_LANDLINE_FAILED = 'REQUEST_CANCEL_LANDLINE_FAILED';

const REQUEST_REMOVE_GROUP = 'REQUEST_REMOVE_GROUP';
const REQUEST_REMOVE_GROUP_SUCCESS = 'REQUEST_REMOVE_GROUP_SUCCESS';
const REQUEST_REMOVE_GROUP_FAILED = 'REQUEST_REMOVE_GROUP_FAILED';

const REQUEST_UPLOAD_LIST_CONTACT = 'REQUEST_UPLOAD_LIST_CONTACT';
const REQUEST_UPLOAD_LIST_CONTACT_SUCCESS = 'REQUEST_UPLOAD_LIST_CONTACT_SUCCESS';
const REQUEST_UPLOAD_LIST_CONTACT_FAILED = 'REQUEST_UPLOAD_LIST_CONTACT_FAILED';

const REQUEST_GET_PREVIEW_LINE = 'REQUEST_GET_PREVIEW_LINE';
const REQUEST_GET_PREVIEW_LINE_SUCCESS = 'REQUEST_GET_PREVIEW_LINE_SUCCESS';
const REQUEST_GET_PREVIEW_LINE_FAILED = 'REQUEST_GET_PREVIEW_LINE_FAILED';

const REQUEST_HEADER_FIELD = 'REQUEST_HEADER_FIELD';
const REQUEST_HEADER_FIELD_SUCCESS = 'REQUEST_HEADER_FIELD_SUCCESS';
const REQUEST_HEADER_FIELD_FAILED = 'REQUEST_HEADER_FIELD_FAILED';

const REQUEST_DELETE_FILE = 'REQUEST_DELETE_FILE';
const REQUEST_DELETE_FILE_SUCCESS = 'REQUEST_DELETE_FILE_SUCCESS';
const REQUEST_DELETE_FILE_FAILED = 'REQUEST_DELETE_FILE_FAILED';

const REQUEST_IMPORT_FROM_STORAGE = 'REQUEST_IMPORT_FROM_STORAGE';
const REQUEST_IMPORT_FROM_STORAGE_SUCCESS = 'REQUEST_IMPORT_FROM_STORAGE_SUCCESS';
const REQUEST_IMPORT_FROM_STORAGE_FAILED = 'REQUEST_IMPORT_FROM_STORAGE_FAILED';

const REQUEST_IMPORT_LIST_CONTACT = 'REQUEST_IMPORT_LIST_CONTACT';
const REQUEST_IMPORT_LIST_CONTACT_SUCCESS = 'REQUEST_IMPORT_LIST_CONTACT_SUCCESS';
const REQUEST_IMPORT_LIST_CONTACT_FAILED = 'REQUEST_IMPORT_LIST_CONTACT_FAILED';

const REQUEST_CHECK_STATUS_IMPORT = 'REQUEST_CHECK_STATUS_IMPORT';
const REQUEST_CHECK_STATUS_IMPORT_SUCCESS = 'REQUEST_CHECK_STATUS_IMPORT_SUCCESS';
const REQUEST_CHECK_STATUS_IMPORT_FAILED = 'REQUEST_CHECK_STATUS_IMPORT_FAILED';
const REQUEST_CHECK_CANCELLED_STATUS_IMPORT = 'REQUEST_CHECK_CANCELLED_STATUS_IMPORT';

const REQUEST_CANCEL_IMPORT = 'REQUEST_CANCEL_IMPORT';
const REQUEST_CANCEL_IMPORT_SUCCESS = 'REQUEST_CANCEL_IMPORT_SUCCESS';
const REQUEST_CANCEL_IMPORT_FAILED = 'REQUEST_CANCEL_IMPORT_FAILED';

const REQUEST_GET_PROCESS_ID_IMPORT = 'REQUEST_GET_PROCESS_ID_IMPORT';
const REQUEST_GET_PROCESS_ID_IMPORT_SUCCESS = 'REQUEST_GET_PROCESS_ID_IMPORT_SUCCESS';
const REQUEST_GET_PROCESS_ID_IMPORT_FAILED = 'REQUEST_GET_PROCESS_ID_IMPORT_FAILED';
const REQUEST_CLEAR_IMPORT_CONTACT = 'REQUEST_CLEAR_IMPORT_CONTACT';

const REQUEST_GET_CARRIER = 'REQUEST_GET_CARRIER';
const REQUEST_GET_CARRIER_FAILED = 'REQUEST_GET_CARRIER_FAILED';
const REQUEST_GET_CARRIER_SUCCESS = 'REQUEST_GET_CARRIER_SUCCESS';

const REQUEST_DELETE_CONTACT_BY_CARRIER = 'REQUEST_DELETE_CONTACT_BY_CARRIER';
const REQUEST_DELETE_CONTACT_BY_CARRIER_SUCCESS = 'REQUEST_DELETE_CONTACT_BY_CARRIER_SUCCESS';
const REQUEST_DELETE_CONTACT_BY_CARRIER_FAILED = 'REQUEST_DELETE_CONTACT_BY_CARRIER_FAILED';

// Dialogs
const REQUEST_GET_LIST_DIALOG = 'REQUEST_GET_LIST_DIALOG';
const REQUEST_GET_LIST_DIALOG_SUCCESS = 'REQUEST_GET_LIST_DIALOG_SUCCESS';
const REQUEST_GET_LIST_DIALOG_FAILED = 'REQUEST_GET_LIST_DIALOG_FAILED';

const REQUEST_GET_LIST_DIALOG_TEMPLATE = 'REQUEST_GET_LIST_DIALOG_TEMPLATE';
const REQUEST_GET_LIST_DIALOG_TEMPLATE_SUCCESS = 'REQUEST_GET_LIST_DIALOG_TEMPLATE_SUCCESS';
const REQUEST_GET_LIST_DIALOG_TEMPLATE_FAILED = 'REQUEST_GET_LIST_DIALOG_TEMPLATE_FAILED';

const REQUEST_SAVE_DIALOG = 'REQUEST_SAVE_DIALOG';
const REQUEST_SAVE_DIALOG_SUCCESS = 'REQUEST_SAVE_DIALOG_SUCCESS';
const REQUEST_SAVE_DIALOG_FAILED = 'REQUEST_SAVE_DIALOG_FAILED';

const REQUEST_SWITCH_RESPONDER = 'REQUEST_SWITCH_RESPONDER';
const REQUEST_SWITCH_RESPONDER_SUCCESS = 'REQUEST_SWITCH_RESPONDER_SUCCESS';
const REQUEST_SWITCH_RESPONDER_FAILED = 'REQUEST_SWITCH_RESPONDER_FAILED';

const REQUEST_DELETE_RESPONDER = 'REQUEST_DELETE_RESPONDER';
const REQUEST_DELETE_RESPONDER_SUCCESS = 'REQUEST_DELETE_RESPONDER_SUCCESS';
const REQUEST_DELETE_RESPONDER_FAILED = 'REQUEST_DELETE_RESPONDER_FAILED';

const REQUEST_ADD_RESPONDER = 'REQUEST_ADD_RESPONDER';
const REQUEST_ADD_RESPONDER_SUCCESS = 'REQUEST_ADD_RESPONDER_SUCCESS';
const REQUEST_ADD_RESPONDER_FAILED = 'REQUEST_ADD_RESPONDER_FAILED';

const REQUEST_GET_RESPONDER_DETAIL = 'REQUEST_GET_RESPONDER_DETAIL';
const REQUEST_GET_RESPONDER_DETAIL_SUCCESS = 'REQUEST_GET_RESPONDER_DETAIL_SUCCESS';
const REQUEST_GET_RESPONDER_DETAIL_FAILED = 'REQUEST_GET_RESPONDER_DETAIL_FAILED';
const CLEAR_RESPONDER_DETAIL = 'CLEAR_RESPONDER_DETAIL';

const REQUEST_SAVE_RESPONDER_CONTENT = 'REQUEST_SAVE_RESPONDER_CONTENT';
const REQUEST_SAVE_RESPONDER_CONTENT_SUCCESS = 'REQUEST_SAVE_RESPONDER_CONTENT_SUCCESS';
const REQUEST_SAVE_RESPONDER_CONTENT_FAILED = 'REQUEST_SAVE_RESPONDER_CONTENT_FAILED';

const REQUEST_DELETE_RESPONDER_CONTENT = 'REQUEST_DELETE_RESPONDER_CONTENT';
const REQUEST_DELETE_RESPONDER_CONTENT_SUCCESS = 'REQUEST_DELETE_RESPONDER_CONTENT_SUCCESS';
const REQUEST_DELETE_RESPONDER_CONTENT_FAILED = 'REQUEST_DELETE_RESPONDER_CONTENT_FAILED';

const REQUEST_UPLOAD_NODE = 'REQUEST_UPLOAD_NODE';
const REQUEST_UPLOAD_NODE_SUCCESS = 'REQUEST_UPLOAD_NODE_SUCCESS';
const REQUEST_UPLOAD_NODE_FAILED = 'REQUEST_UPLOAD_NODE_FAILED';

const REQUEST_SELECTED_NODE = 'REQUEST_SELECTED_NODE';
const CLEAR_SELECTED_NODE = 'CLEAR_SELECTED_NODE';

const REQUEST_GET_LIST_USERS = 'REQUEST_GET_LIST_USERS';
const REQUEST_GET_LIST_USERS_SUCCESS = 'REQUEST_GET_LIST_USERS_SUCCESS';
const REQUEST_GET_LIST_USERS_FAILED = 'REQUEST_GET_LIST_USERS_FAILED';

const REQUEST_SEARCH_LIST_USERS = 'REQUEST_SEARCH_LIST_USERS';
const REQUEST_SEARCH_LIST_USERS_SUCCESS = 'REQUEST_SEARCH_LIST_USERS_SUCCESS';
const REQUEST_SEARCH_LIST_USERS_FAILED = 'REQUEST_SEARCH_LIST_USERS_FAILED';

const REQUEST_DELETE_USERS = 'REQUEST_DELETE_USERS';
const REQUEST_DELETE_USERS_SUCCESS = 'REQUEST_DELETE_USERS_SUCCESS';
const REQUEST_DELETE_USERS_FAILED = 'REQUEST_DELETE_USERS_FAILED';

const REQUEST_CREATE_USERS = 'REQUEST_CREATE_USERS';
const REQUEST_CREATE_USERS_SUCCESS = 'REQUEST_CREATE_USERS_SUCCESS';
const REQUEST_CREATE_USERS_FAILED = 'REQUEST_CREATE_USERS_FAILED';

const REQUEST_SHOW_DIDS = 'REQUEST_SHOW_DIDS';
const REQUEST_SHOW_DIDS_SUCCESS = 'REQUEST_SHOW_DIDS_SUCCESS';
const REQUEST_SHOW_DIDS_FAILED = 'REQUEST_SHOW_DIDS_FAILED';
const CLEAR_SHOW_DIDS = 'CLEAR_SHOW_DIDS';

const REQUEST_SEARCH_DID = 'REQUEST_SEARCH_DID';
const REQUEST_SEARCH_DID_SUCCESS = 'REQUEST_SEARCH_DID_SUCCESS';
const REQUEST_SEARCH_DID_FAILED = 'REQUEST_SEARCH_DID_FAILED';
const CLEAR_DID_KEYWORDS = 'CLEAR_DID_KEYWORDS';

const REQUEST_ADD_DIDS = 'REQUEST_ADD_DIDS';
const REQUEST_ADD_DIDS_SUCCESS = 'REQUEST_ADD_DIDS_SUCCESS';
const REQUEST_ADD_DIDS_FAILED = 'REQUEST_ADD_DIDS_FAILED';

const REQUEST_MIGRATE_DIDS = 'REQUEST_MIGRATE_DIDS';
const REQUEST_MIGRATE_DIDS_SUCCESS = 'REQUEST_MIGRATE_DIDS_SUCCESS';
const REQUEST_MIGRATE_DIDS_FAILED = 'REQUEST_MIGRATE_DIDS_FAILED';

const REQUEST_DELETE_VIRTUALPHONE = 'REQUEST_DELETE_VIRTUALPHONE';
const REQUEST_DELETE_VIRTUALPHONE_SUCCESS = 'REQUEST_DELETE_VIRTUALPHONE_SUCCESS';
const REQUEST_DELETE_VIRTUALPHONE_FAILED = 'REQUEST_DELETE_VIRTUALPHONE_FAILED';

const REQUEST_ADD_CREDITS_USER = 'REQUEST_ADD_CREDITS_USER';
const REQUEST_ADD_CREDITS_USER_SUCCESS = 'REQUEST_ADD_CREDITS_USER_SUCCESS';
const REQUEST_ADD_CREDITS_USER_FAILED = 'REQUEST_ADD_CREDITS_USER_FAILED';

const REQUEST_UPDATE_USER = 'REQUEST_UPDATE_USER';
const REQUEST_UPDATE_USER_SUCCESS = 'REQUEST_UPDATE_USER_SUCCESS';
const REQUEST_UPDATE_USER_FAILED = 'REQUEST_UPDATE_USER_FAILED';

const REQUEST_CLONE_USER = 'REQUEST_CLONE_USER';
const REQUEST_CLONE_USER_SUCCESS = 'REQUEST_CLONE_USER_SUCCESS';
const REQUEST_CLONE_USER_FAILED = 'REQUEST_CLONE_USER_FAILED';

const REQUEST_UPDATE_PROFILE = 'REQUEST_UPDATE_PROFILE';
const REQUEST_UPDATE_PROFILE_SUCCESS = 'REQUEST_UPDATE_PROFILE_SUCCESS';
const REQUEST_UPDATE_PROFILE_FAILED = 'REQUEST_UPDATE_PROFILE_FAILED';

const REQUEST_GET_TABLE_PRICE = 'REQUEST_GET_TABLE_PRICE';
const REQUEST_GET_TABLE_PRICE_SUCCESS = 'REQUEST_GET_TABLE_PRICE_SUCCESS';
const REQUEST_GET_TABLE_PRICE_FAILED = 'REQUEST_GET_TABLE_PRICE_FAILED';

const REQUEST_UPDATE_SETTING = 'REQUEST_UPDATE_SETTING';
const REQUEST_UPDATE_SETTING_SUCCESS = 'REQUEST_UPDATE_SETTING_SUCCESS';
const REQUEST_UPDATE_SETTING_FAILED = 'REQUEST_UPDATE_SETTING_FAILED';

const REQUEST_UPDATE_SETTING_API = 'REQUEST_UPDATE_SETTING_API';
const REQUEST_UPDATE_SETTING_API_SUCCESS = 'REQUEST_UPDATE_SETTING_API_SUCCESS';
const REQUEST_UPDATE_SETTING_API_FAILED = 'REQUEST_UPDATE_SETTING_API_FAILED';

const REQUEST_BACKUP_NOW = 'REQUEST_BACKUP_NOW';
const REQUEST_BACKUP_NOW_SUCCESS = 'REQUEST_BACKUP_NOW_SUCCESS';
const REQUEST_BACKUP_NOW_FAILED = 'REQUEST_BACKUP_NOW_FAILED';

const REQUEST_RESTORE = 'REQUEST_RESTORE';
const REQUEST_RESTORE_SUCCESS = 'REQUEST_RESTORE_SUCCESS';
const REQUEST_RESTORE_FAILED = 'REQUEST_RESTORE_FAILED';

const REQUEST_GET_STATS = 'REQUEST_GET_STATS';
const REQUEST_GET_STATS_SUCCESS = 'REQUEST_GET_STATS_SUCCESS';
const REQUEST_GET_STATS_FAILED = 'REQUEST_GET_STATS_FAILED';

const REQUEST_LIST_DIDS = 'REQUEST_LIST_DIDS';
const REQUEST_LIST_DIDS_SUCCESS = 'REQUEST_LIST_DIDS_SUCCESS';
const REQUEST_LIST_DIDS_FAILED = 'REQUEST_LIST_DIDS_FAILED';

const REQUEST_DID_DETAIL = 'REQUEST_DID_DETAIL';
const REQUEST_DID_DETAIL_SUCCESS = 'REQUEST_DID_DETAIL_SUCCESS';
const REQUEST_DID_DETAIL_FAILED = 'REQUEST_DID_DETAIL_FAILED';

const REQUEST_DELETE_DID = 'REQUEST_DELETE_DID';
const REQUEST_DELETE_DID_SUCCESS = 'REQUEST_DELETE_DID_SUCCESS';
const REQUEST_DELETE_DID_FAILED = 'REQUEST_DELETE_DID_FAILED';

const REQUEST_BULK_PURCHASE = 'REQUEST_BULK_PURCHASE';
const REQUEST_BULK_PURCHASE_SUCCESS = 'REQUEST_BULK_PURCHASE_SUCCESS';
const REQUEST_BULK_PURCHASE_FAILED = 'REQUEST_BULK_PURCHASE_FAILED';

const REQUEST_ADD_DID_GROUP = 'REQUEST_ADD_DID_GROUP';
const REQUEST_ADD_DID_GROUP_SUCCESS = 'REQUEST_ADD_DID_GROUP_SUCCESS';
const REQUEST_ADD_DID_GROUP_FAILED = 'REQUEST_ADD_DID_GROUP_FAILED';

const REQUEST_MOVE_DID = 'REQUEST_MOVE_DID';
const REQUEST_MOVE_DID_SUCCESS = 'REQUEST_MOVE_DID_SUCCESS';
const REQUEST_MOVE_DID_FAILED = 'REQUEST_MOVE_DID_FAILED';
const REQUEST_CLEAR_DID_DETAIL = 'REQUEST_CLEAR_DID_DETAIL';

const REQUEST_ROUTE_LIST = 'REQUEST_ROUTE_LIST';
const REQUEST_ROUTE_LIST_SUCCESS = 'REQUEST_ROUTE_LIST_SUCCESS';
const REQUEST_ROUTE_LIST_FAILED = 'REQUEST_ROUTE_LIST_FAILED';

const REQUEST_EXPORT_USER = 'REQUEST_EXPORT_USER';
const REQUEST_EXPORT_USER_SUCCESS = 'REQUEST_EXPORT_USER_SUCCESS';
const REQUEST_EXPORT_USER_FAILED = 'REQUEST_EXPORT_USER_FAILED';

const REQUEST_EXPORT_CREDIT_STATUS = 'REQUEST_EXPORT_CREDIT_STATUS';
const REQUEST_EXPORT_CREDIT_STATUS_SUCCESS = 'REQUEST_EXPORT_CREDIT_STATUS_SUCCESS';
const REQUEST_EXPORT_CREDIT_STATUS_FAILED = 'REQUEST_EXPORT_CREDIT_STATUS_FAILED';

const REQUEST_EXPORT_CAMPAIN = 'REQUEST_EXPORT_CAMPAIN';
const REQUEST_EXPORT_CAMPAIN_SUCCESS = 'REQUEST_EXPORT_CAMPAIN_SUCCESS';
const REQUEST_EXPORT_CAMPAIN_FAILED = 'REQUEST_EXPORT_CAMPAIN_FAILED';

const REQUEST_ADD_CARD_METHOD = 'REQUEST_ADD_CARD_METHOD';
const REQUEST_ADD_CARD_METHOD_SUCCESS = 'REQUEST_ADD_CARD_METHOD_SUCCESS';
const REQUEST_ADD_CARD_METHOD_FAILED = 'REQUEST_ADD_CARD_METHOD_FAILED';
const RESET_FORM_CARD = 'RESET_FORM_CARD';

const REQUEST_LIST_CARD = 'REQUEST_LIST_CARD';
const REQUEST_LIST_CARD_SUCCESS = 'REQUEST_LIST_CARD_SUCCESS';
const REQUEST_LIST_CARD_FAILED = 'REQUEST_LIST_CARD_FAILED';

const REQUEST_MAKE_DEFAULT = 'REQUEST_MAKE_DEFAULT';
const REQUEST_MAKE_DEFAULT_SUCCESS = 'REQUEST_MAKE_DEFAULT_SUCCESS';
const REQUEST_MAKE_DEFAULT_FAILED = 'REQUEST_MAKE_DEFAULT_FAILED';

const REQUEST_DELETE_CARD = 'REQUEST_DELETE_CARD';
const REQUEST_DELETE_CARD_SUCCESS = 'REQUEST_DELETE_CARD_SUCCESS';
const REQUEST_DELETE_CARD_FAILED = 'REQUEST_DELETE_CARD_FAILED';

const REQUEST_GET_LIST_HISTORY_CHARGE = 'REQUEST_GET_LIST_HISTORY_CHARGE';
const REQUEST_GET_LIST_HISTORY_CHARGE_SUCCESS = 'REQUEST_GET_LIST_HISTORY_CHARGE_SUCCESS';
const REQUEST_GET_LIST_HISTORY_CHARGE_FAILED = 'REQUEST_GET_LIST_HISTORY_CHARGE_FAILED';

const REQUEST_SET_AUTO_RECHARGE = 'REQUEST_SET_AUTO_RECHARGE';
const REQUEST_SET_AUTO_RECHARGE_SUCCESS = 'REQUEST_SET_AUTO_RECHARGE_SUCCESS';
const REQUEST_SET_AUTO_RECHARGE_FAILED = 'REQUEST_SET_AUTO_RECHARGE_FAILED';

const REQUEST_PURCHASE = 'REQUEST_PURCHASE';
const REQUEST_PURCHASE_SUCCESS = 'REQUEST_PURCHASE_SUCCESS';
const REQUEST_PURCHASE_FAILED = 'REQUEST_PURCHASE_FAILED';

const REQUEST_LIST_PACKAGE = 'REQUEST_LIST_PACKAGE';
const REQUEST_LIST_PACKAGE_SUCCESS = 'REQUEST_LIST_PACKAGE_SUCCESS';
const REQUEST_LIST_PACKAGE_FAILED = 'REQUEST_LIST_PACKAGE_FAILED';

const REQUEST_PAYMENT_SELECTED = 'REQUEST_PAYMENT_SELECTED';

const REQUEST_MERGE_GROUPS = 'REQUEST_MERGE_GROUPS';
const REQUEST_MERGE_GROUPS_SUCCESS = 'REQUEST_MERGE_GROUPS_SUCCESS';
const REQUEST_MERGE_GROUPS_FAILED = 'REQUEST_MERGE_GROUPS_FAILED';

const REQUEST_SPLIT_GROUPS = 'REQUEST_SPLIT_GROUPS';
const REQUEST_SPLIT_GROUPS_SUCCESS = 'REQUEST_SPLIT_GROUPS_SUCCESS';
const REQUEST_SPLIT_GROUPS_FAILED = 'REQUEST_SPLIT_GROUPS_FAILED';

const REQUEST_GET_MORE_HISTORY_CHARGE = 'REQUEST_GET_MORE_HISTORY_CHARGE';
const REQUEST_GET_MORE_HISTORY_CHARGE_SUCCESS = 'REQUEST_GET_MORE_HISTORY_CHARGE_SUCCESS';
const REQUEST_GET_MORE_HISTORY_CHARGE_FAILED = 'REQUEST_GET_MORE_HISTORY_CHARGE_FAILED';

const REQUEST_GET_DOMAIN = 'REQUEST_GET_DOMAIN';
const REQUEST_GET_DOMAIN_SUCCESS = 'REQUEST_GET_DOMAIN_SUCCESS';
const REQUEST_GET_DOMAIN_FAILED = 'REQUEST_GET_DOMAIN_FAILED';

const REQUEST_UPDATE_DOMAIN = 'REQUEST_UPDATE_DOMAIN';
const REQUEST_UPDATE_DOMAIN_SUCCESS = 'REQUEST_UPDATE_DOMAIN_SUCCESS';
const REQUEST_UPDATE_DOMAIN_FAILED = 'REQUEST_UPDATE_DOMAIN_FAILED';

const REQUEST_ADD_DOMAIN = 'REQUEST_ADD_DOMAIN';
const REQUEST_ADD_DOMAIN_SUCCESS = 'REQUEST_ADD_DOMAIN_SUCCESS';
const REQUEST_ADD_DOMAIN_FAILED = 'REQUEST_ADD_DOMAIN_FAILED';

const REQUEST_DELETE_DOMAIN = 'REQUEST_DELETE_DOMAIN';
const REQUEST_DELETE_DOMAIN_SUCCESS = 'REQUEST_DELETE_DOMAIN_SUCCESS';
const REQUEST_DELETE_DOMAIN_FAILED = 'REQUEST_DELETE_DOMAIN_FAILED';

const REQUEST_SEARCH_DOMAIN = 'REQUEST_SEARCH_DOMAIN';
const REQUEST_SEARCH_DOMAIN_CANCEL = 'REQUEST_SEARCH_DOMAIN_CANCEL';
const REQUEST_SEARCH_DOMAIN_SUCCESS = 'REQUEST_SEARCH_DOMAIN_SUCCESS';
const REQUEST_SEARCH_DOMAIN_FAILED = 'REQUEST_SEARCH_DOMAIN_FAILED';
const REQUEST_SEARCH_DOMAIN_CANCELLED = 'REQUEST_SEARCH_DOMAIN_CANCELLED';

const REQUEST_BUY_DOMAIN = 'REQUEST_BUY_DOMAIN';
const REQUEST_BUY_DOMAIN_SUCCESS = 'REQUEST_BUY_DOMAIN_SUCCESS';
const REQUEST_BUY_DOMAIN_FAILED = 'REQUEST_BUY_DOMAIN_FAILED';

const REQUEST_UPDATE_ALL_DOMAIN = 'REQUEST_UPDATE_ALL_DOMAIN';
const REQUEST_UPDATE_ALL_DOMAIN_SUCCESS = 'REQUEST_UPDATE_ALL_DOMAIN_SUCCESS';
const REQUEST_UPDATE_ALL_DOMAIN_FAILED = 'REQUEST_UPDATE_ALL_DOMAIN_FAILED';

const REQUEST_SETUP_DOMAIN = 'REQUEST_SETUP_DOMAIN';
const REQUEST_SETUP_DOMAIN_SUCCESS = 'REQUEST_SETUP_DOMAIN_SUCCESS';
const REQUEST_SETUP_DOMAIN_FAILED = 'REQUEST_SETUP_DOMAIN_FAILED';

const REQUEST_CLEAR_DATA_SEARCH_DOMAIN = 'REQUEST_CLEAR_DATA_SEARCH_DOMAIN';

const REQUEST_MESSAGE_STATS = 'REQUEST_MESSAGE_STATS';
const REQUEST_MESSAGE_STATS_SUCCESS = 'REQUEST_MESSAGE_STATS_SUCCESS';
const REQUEST_MESSAGE_STATS_FAILED = 'REQUEST_MESSAGE_STATS_FAILED';

const REQUEST_STATS_BY_TIME = 'REQUEST_STATS_BY_TIME';
const REQUEST_STATS_BY_TIME_SUCCESS = 'REQUEST_STATS_BY_TIME_SUCCESS';
const REQUEST_STATS_BY_TIME_FAILED = 'REQUEST_STATS_BY_TIME_FAILED';

const REQUEST_GET_PURCHASE_PROCESS = 'REQUEST_GET_PURCHASE_PROCESS';
const REQUEST_GET_PURCHASE_PROCESS_SUCCESS = 'REQUEST_GET_PURCHASE_PROCESS_SUCCESS';
const REQUEST_GET_PURCHASE_PROCESS_FAILED = 'REQUEST_GET_PURCHASE_PROCESS_FAILED';

const REQUEST_CHECK_PURCHASE_ALL_GROUP = 'REQUEST_CHECK_PURCHASE_ALL_GROUP';
const REQUEST_CHECK_PURCHASE_ALL_GROUP_SUCCESS = 'REQUEST_CHECK_PURCHASE_ALL_GROUP_SUCCESS';
const REQUEST_CHECK_PURCHASE_ALL_GROUP_FAILED = 'REQUEST_CHECK_PURCHASE_ALL_GROUP_FAILED';

const REQUEST_FILTER_CAMPAIGN = 'REQUEST_FILTER_CAMPAIGN';
const REQUEST_FILTER_CAMPAIGN_SUCCESS = 'REQUEST_FILTER_CAMPAIGN_SUCCESS';
const REQUEST_FILTER_CAMPAIGN_FAILED = 'REQUEST_FILTER_CAMPAIGN_FAILED';

const REQUEST_PULL_REVENUE_CAMPAIGN = 'REQUEST_PULL_REVENUE_CAMPAIGN';
const REQUEST_PULL_REVENUE_CAMPAIGN_SUCCESS = 'REQUEST_PULL_REVENUE_CAMPAIGN_SUCCESS';
const REQUEST_PULL_REVENUE_CAMPAIGN_FAILED = 'REQUEST_PULL_REVENUE_CAMPAIGN_FAILED';

const REQUEST_PHONE_NUMBERS = 'REQUEST_PHONE_NUMBERS';
const REQUEST_PHONE_NUMBERS_SUCCESS = 'REQUEST_PHONE_NUMBERS_SUCCESS';
const REQUEST_PHONE_NUMBERS_FAILED = 'REQUEST_PHONE_NUMBERS_FAILED';

const CHANGE_FILTER_CAMPAIGN = 'CHANGE_FILTER_CAMPAIGN';
const CHANGE_FILTER_OFFERS = 'CHANGE_FILTER_OFFERS';
const CHANGE_FILTER_CREATIVE = 'CHANGE_FILTER_CREATIVE';

const REQUEST_FILTER_OFFERS = 'REQUEST_FILTER_OFFERS';
const REQUEST_FILTER_OFFERS_SUCCESS = 'REQUEST_FILTER_OFFERS_SUCCESS';
const REQUEST_FILTER_OFFERS_FAILED = 'REQUEST_FILTER_OFFERS_FAILED';

const REQUEST_FILTER_CREATIVE = 'REQUEST_FILTER_CREATIVE';
const REQUEST_FILTER_CREATIVE_SUCCESS = 'REQUEST_FILTER_CREATIVE_SUCCESS';
const REQUEST_FILTER_CREATIVE_FAILED = 'REQUEST_FILTER_CREATIVE_FAILED';

// CREATIVE
const REQUEST_GET_LIST_CREATIVE = 'REQUEST_GET_LIST_CREATIVE';
const REQUEST_GET_LIST_CREATIVE_SUCCESS = 'REQUEST_GET_LIST_CREATIVE_SUCCESS';
const REQUEST_GET_LIST_CREATIVE_FAILED = 'REQUEST_GET_LIST_CREATIVE_FAILED';

const REQUEST_GET_CREATIVE_BY_ID = 'REQUEST_GET_CREATIVE_BY_ID';
const REQUEST_GET_CREATIVE_BY_ID_SUCCESS = 'REQUEST_GET_CREATIVE_BY_ID_SUCCESS';
const REQUEST_GET_CREATIVE_BY_ID_FAILED = 'REQUEST_GET_CREATIVE_BY_ID_FAILED';

const REQUEST_CREATE_CREATIVE = 'REQUEST_CREATE_CREATIVE';
const REQUEST_CREATE_CREATIVE_SUCCESS = 'REQUEST_CREATE_CREATIVE_SUCCESS';
const REQUEST_CREATE_CREATIVE_FAILED = 'REQUEST_CREATE_CREATIVE_FAILED';

const REQUEST_DELETE_CREATIVE = 'REQUEST_DELETE_CREATIVE';
const REQUEST_DELETE_CREATIVE_SUCCESS = 'REQUEST_DELETE_CREATIVE_SUCCESS';
const REQUEST_DELETE_CREATIVE_FAILED = 'REQUEST_DELETE_CREATIVE_FAILED';

const REQUEST_UPDATE_CREATIVE = 'REQUEST_UPDATE_CREATIVE';
const REQUEST_UPDATE_CREATIVE_SUCCESS = 'REQUEST_UPDATE_CREATIVE_SUCCESS';
const REQUEST_UPDATE_CREATIVE_FAILED = 'REQUEST_UPDATE_CREATIVE_FAILED';

// OFFERS
const REQUEST_DELETE_OFFER = 'REQUEST_DELETE_OFFER';
const REQUEST_DELETE_OFFER_SUCCESS = 'REQUEST_DELETE_OFFER_SUCCESS';
const REQUEST_DELETE_OFFER_FAILED = 'REQUEST_DELETE_OFFER_FAILED';

const REQUEST_GET_OFFER_BY_ID = 'REQUEST_GET_OFFER_BY_ID';
const REQUEST_GET_OFFER_BY_ID_SUCCESS = 'REQUEST_GET_OFFER_BY_ID_SUCCESS';
const REQUEST_GET_OFFER_BY_ID_FAILED = 'REQUEST_GET_OFFER_BY_ID_FAILED';

const REQUEST_UPDATE_OFFER = 'REQUEST_UPDATE_OFFER';
const REQUEST_UPDATE_OFFER_SUCCESS = 'REQUEST_UPDATE_OFFER_SUCCESS';
const REQUEST_UPDATE_OFFER_FAILED = 'REQUEST_UPDATE_OFFER_FAILED';

const REQUEST_GET_LIST_OFFER = 'REQUEST_GET_LIST_OFFER';
const REQUEST_GET_LIST_OFFER_SUCCESS = 'REQUEST_GET_LIST_OFFER_SUCCESS';
const REQUEST_GET_LIST_OFFER_FAILED = 'REQUEST_GET_LIST_OFFER_FAILED';

const REQUEST_CREATE_OFFER = 'REQUEST_CREATE_OFFER';
const REQUEST_CREATE_OFFER_SUCCESS = 'REQUEST_CREATE_OFFER_SUCCESS';
const REQUEST_CREATE_OFFER_FAILED = 'REQUEST_CREATE_OFFER_FAILED';

// CREATIVE_CAMPAIGN
const REQUEST_GET_CREATIVE_BY_CAMPAIGN_ID = 'REQUEST_GET_CREATIVE_BY_CAMPAIGN_ID';
const REQUEST_GET_CREATIVE_BY_CAMPAIGN_ID_SUCCESS = 'REQUEST_GET_CREATIVE_BY_CAMPAIGN_ID_SUCCESS';
const REQUEST_GET_CREATIVE_BY_CAMPAIGN_ID_FAILED = 'REQUEST_GET_CREATIVE_BY_CAMPAIGN_ID_FAILED';

const REQUEST_UPDATE_CREATIVE_CAMPAIGN = 'REQUEST_UPDATE_CREATIVE_CAMPAIGN';
const REQUEST_UPDATE_CREATIVE_CAMPAIGN_SUCCESS = 'REQUEST_UPDATE_CREATIVE_CAMPAIGN_SUCCESS';
const REQUEST_UPDATE_CREATIVE_CAMPAIGN_FAILED = 'REQUEST_UPDATE_CREATIVE_CAMPAIGN_FAILED';
const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
const REQUEST_UPLOAD_ATTACHMENTS_CREATIVE = 'REQUEST_UPLOAD_ATTACHMENTS_CREATIVE';
const REQUEST_UPLOAD_ATTACHMENTS_CREATIVE_SUCCESS = 'REQUEST_UPLOAD_ATTACHMENTS_CREATIVE_SUCCESS';
const REQUEST_UPLOAD_ATTACHMENTS_CREATIVE_FAILED = 'REQUEST_UPLOAD_ATTACHMENTS_CREATIVE_FAILED';
const REQUEST_DELETE_ATTACHMENT = 'REQUEST_DELETE_ATTACHMENT';
const REQUEST_DELETE_ATTACHMENT_SUCCESS = 'REQUEST_DELETE_ATTACHMENT_SUCCESS';
const REQUEST_DELETE_ATTACHMENT_FAILED = 'REQUEST_DELETE_ATTACHMENT_FAILED';

// OFFER_CAMPAIGN
const REQUEST_UPDATE_OFFER_CAMPAIGN = 'REQUEST_UPDATE_OFFER_CAMPAIGN';
const REQUEST_UPDATE_OFFER_CAMPAIGN_SUCCESS = 'REQUEST_UPDATE_OFFER_CAMPAIGN_SUCCESS';
const REQUEST_UPDATE_OFFER_CAMPAIGN_FAILED = 'REQUEST_UPDATE_OFFER_CAMPAIGN_FAILED';

// NOTIFICATION
const REQUEST_GET_NOTIFICATION = 'REQUEST_GET_NOTIFICATION';
const REQUEST_GET_NOTIFICATION_SUCCESS = 'REQUEST_GET_NOTIFICATION_SUCCESS';
const REQUEST_GET_NOTIFICATION_FAILED = 'REQUEST_GET_NOTIFICATION_FAILED';

const REQUEST_UPDATE_NOTIFICATION = 'REQUEST_UPDATE_NOTIFICATION';
const REQUEST_UPDATE_NOTIFICATION_SUCCESS = 'REQUEST_UPDATE_NOTIFICATION_SUCCESS';
const REQUEST_UPDATE_NOTIFICATION_FAILED = 'REQUEST_UPDATE_NOTIFICATION_FAILED';
const CHANGE_FILTER_NOTIFICATION = 'CHANGE_FILTER_NOTIFICATION';
const REQUEST_GET_MORE_NOTIFICATION_SUCCESS = 'REQUEST_GET_MORE_NOTIFICATION_SUCCESS';

// DOMAIN-GROUP
const REQUEST_GET_ALL_DOMAIN_GROUP = 'REQUEST_GET_ALL_DOMAIN_GROUP';
const REQUEST_GET_ALL_DOMAIN_GROUP_SUCCESS = 'REQUEST_GET_ALL_DOMAIN_GROUP_SUCCESS';
const REQUEST_GET_ALL_DOMAIN_GROUP_FAILED = 'REQUEST_GET_ALL_DOMAIN_GROUP_FAILED';

const REQUEST_CREATE_DOMAIN_GROUP = 'REQUEST_CREATE_DOMAIN_GROUP';
const REQUEST_CREATE_DOMAIN_GROUP_SUCCESS = 'REQUEST_CREATE_DOMAIN_GROUP_SUCCESS';
const REQUEST_CREATE_DOMAIN_GROUP_FAILED = 'REQUEST_CREATE_DOMAIN_GROUP_FAILED';

const REQUEST_DELETE_DOMAIN_GROUP = 'REQUEST_DELETE_DOMAIN_GROUP';
const REQUEST_DELETE_DOMAIN_GROUP_SUCCESS = 'REQUEST_DELETE_DOMAIN_GROUP_SUCCESS';
const REQUEST_DELETE_DOMAIN_GROUP_FAILED = 'REQUEST_DELETE_DOMAIN_GROUP_FAILED';

const REQUEST_MIGRATE_DOMAIN_GROUP = 'REQUEST_MIGRATE_DOMAIN_GROUP';
const REQUEST_MIGRATE_DOMAIN_GROUP_SUCCESS = 'REQUEST_MIGRATE_DOMAIN_GROUP_SUCCESS';
const REQUEST_MIGRATE_DOMAIN_GROUP_FAILED = 'REQUEST_MIGRATE_DOMAIN_GROUP_FAILED';

const REQUEST_SAVE_DOMAIN_GROUP_SETTING = 'REQUEST_SAVE_DOMAIN_GROUP_SETTING';
const REQUEST_SAVE_DOMAIN_GROUP_SETTING_SUCCESS = 'REQUEST_SAVE_DOMAIN_GROUP_SETTING_SUCCESS';
const REQUEST_SAVE_DOMAIN_GROUP_SETTING_FAILED = 'REQUEST_SAVE_DOMAIN_GROUP_SETTING_FAILED';

const REQUEST_LOAD_DOMAINS_IN_GROUP = 'REQUEST_LOAD_DOMAINS_IN_GROUP';
const REQUEST_LOAD_DOMAINS_IN_GROUP_SUCCESS = 'REQUEST_LOAD_DOMAINS_IN_GROUP_SUCCESS';
const REQUEST_LOAD_DOMAINS_IN_GROUP_FAILED = 'REQUEST_LOAD_DOMAINS_IN_GROUP_FAILED';

const REQUEST_UPDATE_DOMAIN_CAMPAIGN = 'REQUEST_UPDATE_DOMAIN_CAMPAIGN';
const REQUEST_UPDATE_DOMAIN_CAMPAIGN_SUCCESS = 'REQUEST_UPDATE_DOMAIN_CAMPAIGN_SUCCESS';
const REQUEST_UPDATE_DOMAIN_CAMPAIGN_FAILED = 'REQUEST_UPDATE_DOMAIN_CAMPAIGN_FAILED';

const REQUEST_RESET_DOMAIN_IN_GROUP = 'REQUEST_RESET_DOMAIN_IN_GROUP';

const REQUEST_DELETE_SINGLE_DID = 'REQUEST_DELETE_SINGLE_DID';
const REQUEST_DELETE_SINGLE_DID_SUCCESS = 'REQUEST_DELETE_SINGLE_DID_SUCCESS';
const REQUEST_DELETE_SINGLE_DID_FAILED = 'REQUEST_DELETE_SINGLE_DID_FAILED';

const REQUEST_SET_DID_GROUP_RESPONDER = 'REQUEST_SET_DID_GROUP_RESPONDER';
const REQUEST_SET_DID_GROUP_RESPONDER_SUCCESS = 'REQUEST_SET_DID_GROUP_RESPONDER_SUCCESS';
const REQUEST_SET_DID_GROUP_RESPONDER_FAILED = 'REQUEST_SET_DID_GROUP_RESPONDER_FAILED';

const REQUEST_REGENERATE_API_KEY = 'REQUEST_REGENERATE_API_KEY';
const REQUEST_REGENERATE_API_KEY_SUCCESS = 'REQUEST_REGENERATE_API_KEY_SUCCESS';
const REQUEST_REGENERATE_API_KEY_FAILED = 'REQUEST_REGENERATE_API_KEY_FAILED';

const UPDATE_INBOX_DETAIL = 'UPDATE_INBOX_DETAIL';

const REQUEST_SEARCH_CONTACT_SERVLET = 'REQUEST_SEARCH_CONTACT_SERVLET';
const REQUEST_SEARCH_CONTACT_SERVLET_SUCCESS = 'REQUEST_SEARCH_CONTACT_SERVLET_SUCCESS';
const REQUEST_SEARCH_CONTACT_SERVLET_FAILED = 'REQUEST_SEARCH_CONTACT_SERVLET_FAILED';

const REQUEST_MOVE_DID_SELECTED = 'REQUEST_MOVE_DID_SELECTED';
const REQUEST_MOVE_DID_SELECTED_SUCCESS = 'REQUEST_MOVE_DID_SELECTED_SUCCESS';
const REQUEST_MOVE_DID_SELECTED_FAILED = 'REQUEST_MOVE_DID_SELECTED_FAILED';

const REQUEST_CHANGE_NAME_CONTACT = 'REQUEST_CHANGE_NAME_CONTACT';
const REQUEST_CHANGE_NAME_CONTACT_SUCCESS = 'REQUEST_CHANGE_NAME_CONTACT_SUCCESS';
const REQUEST_CHANGE_NAME_CONTACT_FAILED = 'REQUEST_CHANGE_NAME_CONTACT_FAILED';

const CHANGE_THEME = 'CHANGE_THEME';
const CHANGE_TYPE_CONTACT = 'CHANGE_TYPE_CONTACT';

const REQUEST_LOAD_MORE_CONTACT = 'REQUEST_LOAD_MORE_CONTACT';
const REQUEST_LOAD_MORE_CONTACT_SUCCESS = 'REQUEST_LOAD_MORE_CONTACT_SUCCESS';
const REQUEST_LOAD_MORE_CONTACT_FAILED = 'REQUEST_LOAD_MORE_CONTACT_FAILED';

const REQUEST_LOAD_MORE_RESPONDER = 'REQUEST_LOAD_MORE_RESPONDER';
const REQUEST_LOAD_MORE_RESPONDER_SUCCESS = 'REQUEST_LOAD_MORE_RESPONDER_SUCCESS';
const REQUEST_LOAD_MORE_RESPONDER_FAILED = 'REQUEST_LOAD_MORE_RESPONDER_FAILED';

const REQUEST_FILTER_RESPONDER = 'REQUEST_FILTER_RESPONDER';
const REQUEST_FILTER_RESPONDER_SUCCESS = 'REQUEST_FILTER_RESPONDER_SUCCESS';
const REQUEST_FILTER_RESPONDER_FAILED = 'REQUEST_FILTER_RESPONDER_FAILED';

const REQUEST_REFETCH_RESPONDER_SUCCESS = 'REQUEST_REFETCH_RESPONDER_SUCCESS';
const REQUEST_REFETCH_RESPONDER_FAILED = 'REQUEST_REFETCH_RESPONDER_FAILED';

const REQUEST_SAVE_DID = 'REQUEST_SAVE_DID';
const REQUEST_SAVE_DID_SUCCESS = 'REQUEST_SAVE_DID_SUCCESS';
const REQUEST_SAVE_DID_FAILED = 'REQUEST_SAVE_DID_FAILED';

const REQUEST_RELEASE_DID_NOW = 'REQUEST_RELEASE_DID_NOW';
const REQUEST_RELEASE_DID_NOW_SUCCESS = 'REQUEST_RELEASE_DID_NOW_SUCCESS';
const REQUEST_RELEASE_DID_NOW_FAILED = 'REQUEST_RELEASE_DID_NOW_FAILED';

const REQUEST_LOAD_MORE_DIDS_GROUP = 'REQUEST_LOAD_MORE_DIDS_GROUP';
const REQUEST_LOAD_MORE_DIDS_GROUP_SUCCESS = 'REQUEST_LOAD_MORE_DIDS_GROUP_SUCCESS';
const REQUEST_LOAD_MORE_DIDS_GROUP_FAILED = 'REQUEST_LOAD_MORE_DIDS_GROUP_FAILED';

const REQUEST_LOAD_MORE_ALL_DOMAIN = 'REQUEST_LOAD_MORE_ALL_DOMAIN';
const REQUEST_LOAD_MORE_ALL_DOMAIN_SUCCESS = 'REQUEST_LOAD_MORE_ALL_DOMAIN_SUCCESS';
const REQUEST_LOAD_MORE_ALL_DOMAIN_FAILED = 'REQUEST_LOAD_MORE_ALL_DOMAIN_FAILED';

const REQUEST_GET_GUIDE = 'REQUEST_GET_GUIDE';
const REQUEST_GET_GUIDE_SUCCESS = 'REQUEST_GET_GUIDE_SUCCESS';
const REQUEST_GET_GUIDE_FAILED = 'REQUEST_GET_GUIDE_FAILED';

const REQUEST_GET_GUIDE_BY_ROLE = 'REQUEST_GET_GUIDE_BY_ROLE';
const REQUEST_GET_GUIDE_BY_ROLE_SUCCESS = 'REQUEST_GET_GUIDE_BY_ROLE_SUCCESS';
const REQUEST_GET_GUIDE_BY_ROLE_FAILED = 'REQUEST_GET_GUIDE_BY_ROLE_FAILED';

const REQUEST_SAVE_GUIDE = 'REQUEST_SAVE_GUIDE';
const REQUEST_SAVE_GUIDE_SUCCESS = 'REQUEST_SAVE_GUIDE_SUCCESS';
const REQUEST_SAVE_GUIDE_FAILED = 'REQUEST_SAVE_GUIDE_FAILED';

const REQUEST_REORDER_GUIDE = 'REQUEST_REORDER_GUIDE';
const REQUEST_REORDER_GUIDE_SUCCESS = 'REQUEST_REORDER_GUIDE_SUCCESS';
const REQUEST_REORDER_GUIDE_FAILED = 'REQUEST_REORDER_GUIDE_FAILED';

const REQUEST_DELETE_GUIDE = 'REQUEST_DELETE_GUIDE';
const REQUEST_DELETE_GUIDE_SUCCESS = 'REQUEST_DELETE_GUIDE_SUCCESS';
const REQUEST_DELETE_GUIDE_FAILED = 'REQUEST_DELETE_GUIDE_FAILED';

const REQUEST_COUNT_NOTIFICATION_SUCCESS = 'REQUEST_COUNT_NOTIFICATION_SUCCESS';
const REQUEST_COUNT_NOTIFICATION_FAILED = 'REQUEST_COUNT_NOTIFICATION_FAILED';

const REQUEST_LOAD_MORE_NOTIFICATION = 'REQUEST_LOAD_MORE_NOTIFICATION';
const REQUEST_LOAD_MORE_NOTIFICATION_SUCCESS = 'REQUEST_LOAD_MORE_NOTIFICATION_SUCCESS';
const REQUEST_LOAD_MORE_NOTIFICATION_FAILED = 'REQUEST_LOAD_MORE_NOTIFICATION_FAILED';

const REQUEST_RE_FETCH_NOTIFICATION = 'REQUEST_RE_FETCH_NOTIFICATION';
const REQUEST_RE_FETCH_NOTIFICATION_SUCCESS = 'REQUEST_RE_FETCH_NOTIFICATION_SUCCESS';
const REQUEST_RE_FETCH_NOTIFICATION_FAILED = 'REQUEST_RE_FETCH_NOTIFICATION_FAILED';

const REQUEST_MARK_AS_ALL_READ = 'REQUEST_MARK_AS_ALL_READ';
const REQUEST_MARK_AS_ALL_READ_SUCCESS = 'REQUEST_MARK_AS_ALL_READ_SUCCESS';
const REQUEST_MARK_AS_ALL_READ_FAILED = 'REQUEST_MARK_AS_ALL_READ_FAILED';

const REQUEST_GET_DATA_CONSUMING = 'REQUEST_GET_DATA_CONSUMING';
const REQUEST_GET_DATA_CONSUMING_SUCCESS = 'REQUEST_GET_DATA_CONSUMING_SUCCESS';
const REQUEST_GET_DATA_CONSUMING_FAILED = 'REQUEST_GET_DATA_CONSUMING_FAILED';

const REQUEST_START_DATA_CONSUMING = 'REQUEST_START_DATA_CONSUMING';
const REQUEST_START_DATA_CONSUMING_SUCCESS = 'REQUEST_START_DATA_CONSUMING_SUCCESS';
const REQUEST_START_DATA_CONSUMING_FAILED = 'REQUEST_START_DATA_CONSUMING_FAILED';

const REQUEST_GET_DATA_REFRESHING = 'REQUEST_GET_DATA_REFRESHING';
const REQUEST_GET_DATA_REFRESHING_SUCCESS = 'REQUEST_GET_DATA_REFRESHING_SUCCESS';
const REQUEST_GET_DATA_REFRESHING_FAILED = 'REQUEST_GET_DATA_REFRESHING_FAILED';

const REQUEST_START_DATA_REFRESHING = 'REQUEST_START_DATA_REFRESHING';
const REQUEST_START_DATA_REFRESHING_SUCCESS = 'REQUEST_START_DATA_REFRESHING_SUCCESS';
const REQUEST_START_DATA_REFRESHING_FAILED = 'REQUEST_START_DATA_REFRESHING_FAILED';

const REQUEST_GET_LIST_TICKETS = 'REQUEST_GET_LIST_TICKETS';
const REQUEST_GET_LIST_TICKETS_SUCCESS = 'REQUEST_GET_LIST_TICKETS_SUCCESS';
const REQUEST_GET_LIST_TICKETS_FAILED = 'REQUEST_GET_LIST_TICKETS_FAILED';

const REQUEST_DELETE_TICKET = 'REQUEST_DELETE_TICKET';
const REQUEST_DELETE_TICKET_SUCCESS = 'REQUEST_DELETE_TICKET_SUCCESS';
const REQUEST_DELETE_TICKET_FAILED = 'REQUEST_DELETE_TICKET_FAILED';

const REQUEST_GET_TICKET_BY_ID = 'REQUEST_GET_TICKET_BY_ID';
const REQUEST_GET_TICKET_BY_ID_SUCCESS = 'REQUEST_GET_TICKET_BY_ID_SUCCESS';
const REQUEST_GET_TICKET_BY_ID_FAILED = 'REQUEST_GET_TICKET_BY_ID_FAILED';

const REQUEST_EDIT_TICKET = 'REQUEST_EDIT_TICKET';
const REQUEST_EDIT_TICKET_SUCCESS = 'REQUEST_EDIT_TICKET_SUCCESS';
const REQUEST_EDIT_TICKET_FAILED = 'REQUEST_EDIT_TICKET_FAILED';

const REQUEST_CREATE_TICKET = 'REQUEST_CREATE_TICKET';
const REQUEST_CREATE_TICKET_SUCCESS = 'REQUEST_CREATE_TICKET_SUCCESS';
const REQUEST_CREATE_TICKET_FAILED = 'REQUEST_CREATE_TICKET_FAILED';

const REQUEST_ADD_COMMENT_TICKET = 'REQUEST_ADD_COMMENT_TICKET';
const REQUEST_ADD_COMMENT_TICKET_SUCCESS = 'REQUEST_ADD_COMMENT_TICKET_SUCCESS';
const REQUEST_ADD_COMMENT_TICKET_FAILED = 'REQUEST_ADD_COMMENT_TICKET_FAILED';

const REQUEST_EDIT_COMMENT_TICKET = 'REQUEST_EDIT_COMMENT_TICKET';
const REQUEST_EDIT_COMMENT_TICKET_SUCCESS = 'REQUEST_EDIT_COMMENT_TICKET_SUCCESS';
const REQUEST_EDIT_COMMENT_TICKET_FAILED = 'REQUEST_EDIT_COMMENT_TICKET_FAILED';

const REQUEST_DELETE_COMMENT_TICKET = 'REQUEST_DELETE_COMMENT_TICKET';
const REQUEST_DELETE_COMMENT_TICKET_SUCCESS = 'REQUEST_DELETE_COMMENT_TICKET_SUCCESS';
const REQUEST_DELETE_COMMENT_TICKET_FAILED = 'REQUEST_DELETE_COMMENT_TICKET_FAILED';

const REQUEST_GET_HIGHLIGHT_HIST = 'REQUEST_GET_HIGHLIGHT_HIST';
const REQUEST_GET_HIGHLIGHT_HIST_SUCCESS = 'REQUEST_GET_HIGHLIGHT_HIST_SUCCESS';
const REQUEST_GET_HIGHLIGHT_HIST_FAILED = 'REQUEST_GET_HIGHLIGHT_HIST_FAILED';

const REQUEST_UPDATE_REQUEST_CLICK = 'REQUEST_UPDATE_REQUEST_CLICK';
const REQUEST_UPDATE_REQUEST_CLICK_SUCCESS = 'REQUEST_UPDATE_REQUEST_CLICK_SUCCESS';
const REQUEST_UPDATE_REQUEST_CLICK_FAILED = 'REQUEST_UPDATE_REQUEST_CLICK_FAILED';

const REQUEST_GET_CAMPAIGN_IN_DOMAIN = 'REQUEST_GET_CAMPAIGN_IN_DOMAIN';
const REQUEST_GET_CAMPAIGN_IN_DOMAIN_SUCCESS = 'REQUEST_GET_CAMPAIGN_IN_DOMAIN_SUCCESS';
const REQUEST_GET_CAMPAIGN_IN_DOMAIN_FAILED = 'REQUEST_GET_CAMPAIGN_IN_DOMAIN_FAILED';
const REQUEST_LOAD_MORE_CAMPAIGN_IN_DOMAIN = 'REQUEST_LOAD_MORE_CAMPAIGN_IN_DOMAIN';

const REQUEST_GET_RESPONDER_IN_DOMAIN = 'REQUEST_GET_RESPONDER_IN_DOMAIN';
const REQUEST_GET_RESPONDER_IN_DOMAIN_SUCCESS = 'REQUEST_GET_RESPONDER_IN_DOMAIN_SUCCESS';
const REQUEST_GET_RESPONDER_IN_DOMAIN_FAILED = 'REQUEST_GET_RESPONDER_IN_DOMAIN_FAILED';

const REQUEST_CHECK_IMPORTING = 'REQUEST_CHECK_IMPORTING';
const REQUEST_CHECK_IMPORTING_SUCCESS = 'REQUEST_CHECK_IMPORTING_SUCCESS';
const REQUEST_CHECK_IMPORTING_CANCELED = 'REQUEST_CHECK_IMPORTING_CANCELED';
const REQUEST_CHECK_IMPORTING_FAILED = 'REQUEST_CHECK_IMPORTING_FAILED';

const REQUEST_CHECK_SCRUBBING = 'REQUEST_CHECK_SCRUBBING';
const REQUEST_CHECK_SCRUBBING_SUCCESS = 'REQUEST_CHECK_SCRUBBING_SUCCESS';
const REQUEST_CHECK_SCRUBBING_CANCELED = 'REQUEST_CHECK_SCRUBBING_CANCELED';
const REQUEST_CHECK_SCRUBBING_FAILED = 'REQUEST_CHECK_SCRUBBING_FAILED';

const REQUEST_REFETCH_CONTACTS = 'REQUEST_REFETCH_CONTACTS';
const REQUEST_GET_TOTAL_DID_IN_ACCOUNT = 'REQUEST_GET_TOTAL_DID_IN_ACCOUNT';
const REQUEST_GET_TOTAL_DID_IN_ACCOUNT_SUCCESS = 'REQUEST_GET_TOTAL_DID_IN_ACCOUNT_SUCCESS';
const REQUEST_GET_TOTAL_DID_IN_ACCOUNT_FAILED = 'REQUEST_GET_TOTAL_DID_IN_ACCOUNT_FAILED';

const REQUEST_RELEASE_DOMAIN_NOW = 'REQUEST_RELEASE_DOMAIN_NOW';
const REQUEST_RELEASE_DOMAIN_NOW_SUCCESS = 'REQUEST_RELEASE_DOMAIN_NOW_SUCCESS';
const REQUEST_RELEASE_DOMAIN_NOW_FAILED = 'REQUEST_RELEASE_DOMAIN_NOW_FAILED';

const REQUEST_GET_CAMPAIGN_STATS = 'REQUEST_GET_CAMPAIGN_STATS';
const REQUEST_GET_CAMPAIGN_STATS_SUCCESS = 'REQUEST_GET_CAMPAIGN_STATS_SUCCESS';
const REQUEST_GET_CAMPAIGN_STATS_FAILED = 'REQUEST_GET_CAMPAIGN_STATS_FAILED';

const REQUEST_CREATE_ORDER = 'REQUEST_CREATE_ORDER';
const REQUEST_CREATE_ORDER_SUCCESS = 'REQUEST_CREATE_ORDER_SUCCESS';
const REQUEST_CREATE_ORDER_FAILED = 'REQUEST_CREATE_ORDER_FAILED';

const REQUEST_GET_LIST_ORDER = 'REQUEST_GET_LIST_ORDER';
const REQUEST_GET_LIST_ORDER_SUCCESS = 'REQUEST_GET_LIST_ORDER_SUCCESS';
const REQUEST_GET_LIST_ORDER_FAILED = 'REQUEST_GET_LIST_ORDER_FAILED';

const REQUEST_CHECK_CREDIT = 'REQUEST_CHECK_CREDIT';
const REQUEST_CHECK_CREDIT_SUCCESS = 'REQUEST_CHECK_CREDIT_SUCCESS';
const REQUEST_CHECK_CREDIT_FAILED = 'REQUEST_CHECK_CREDIT_FAILED';

const REQUEST_SAVE_LEAD_FILTER = 'REQUEST_SAVE_LEAD_FILTER';
const REQUEST_SAVE_LEAD_FILTER_SUCCESS = 'REQUEST_SAVE_LEAD_FILTER_SUCCESS';
const REQUEST_SAVE_LEAD_FILTER_FAILED = 'REQUEST_SAVE_LEAD_FILTER_FAILED';

const REQUEST_RELEASE_DID_BY_CLICK_RATE = 'REQUEST_RELEASE_DID_BY_CLICK_RATE';
const REQUEST_RELEASE_DID_BY_CLICK_RATE_SUCCESS = 'REQUEST_RELEASE_DID_BY_CLICK_RATE_SUCCESS';
const REQUEST_RELEASE_DID_BY_CLICK_RATE_FAILED = 'REQUEST_RELEASE_DID_BY_CLICK_RATE_FAILED';

const REQUEST_SET_LEAD_CALLBACK_LINK = 'REQUEST_SET_LEAD_CALLBACK_LINK';
const REQUEST_SET_LEAD_CALLBACK_LINK_SUCCESS = 'REQUEST_SET_LEAD_CALLBACK_LINK_SUCCESS';
const REQUEST_SET_LEAD_CALLBACK_LINK_FAILED = 'REQUEST_SET_LEAD_CALLBACK_LINK_FAILED';

const REQUEST_REFRESH_CAMPAIGN = 'REQUEST_REFRESH_CAMPAIGN';
const REQUEST_REFRESH_CAMPAIGN_SUCCESS = 'REQUEST_REFRESH_CAMPAIGN_SUCCESS';
const REQUEST_REFRESH_CAMPAIGN_FAILED = 'REQUEST_REFRESH_CAMPAIGN_FAILED';

const REQUEST_RELEASE_DOMAIN_SELECTED = 'REQUEST_RELEASE_DOMAIN_SELECTED';
const REQUEST_RELEASE_DOMAIN_SELECTED_SUCCESS = 'REQUEST_RELEASE_DOMAIN_SELECTED_SUCCESS';
const REQUEST_RELEASE_DOMAIN_SELECTED_FAILED = 'REQUEST_RELEASE_DOMAIN_SELECTED_FAILED';

const REQUEST_GET_BUYING_PROCESS = 'REQUEST_GET_BUYING_PROCESS';
const REQUEST_GET_BUYING_PROCESS_SUCCESS = 'REQUEST_GET_BUYING_PROCESS_SUCCESS';
const REQUEST_GET_BUYING_PROCESS_FAILED = 'REQUEST_GET_BUYING_PROCESS_FAILED';

const REQUEST_RESEND_TO_FAILED_CONTACTS = 'REQUEST_RESEND_TO_FAILED_CONTACTS';
const REQUEST_RESEND_TO_FAILED_CONTACTS_SUCCESS = 'REQUEST_RESEND_TO_FAILED_CONTACTS_SUCCESS';
const REQUEST_RESEND_TO_FAILED_CONTACTS_FAILED = 'REQUEST_RESEND_TO_FAILED_CONTACTS_FAILED';

const REQUEST_SWITCH_STATUS_ROUTE_HISTORY = 'REQUEST_SWITCH_STATUS_ROUTE_HISTORY';
const REQUEST_SWITCH_STATUS_ROUTE_HISTORY_SUCCESS = 'REQUEST_SWITCH_STATUS_ROUTE_HISTORY_SUCCESS';
const REQUEST_SWITCH_STATUS_ROUTE_HISTORY_FAILED = 'REQUEST_SWITCH_STATUS_ROUTE_HISTORY_FAILED';

const REQUEST_GET_MONITORING = 'REQUEST_GET_MONITORING';
const REQUEST_GET_MONITORING_SUCCESS = 'REQUEST_GET_MONITORING_SUCCESS';
const REQUEST_GET_MONITORING_FAILED = 'REQUEST_GET_MONITORING_FAILED';

const REQUEST_SORTING_CAMPAIGN = 'REQUEST_SORTING_CAMPAIGN';
const REQUEST_SORTING_CAMPAIGN_SUCCESS = 'REQUEST_SORTING_CAMPAIGN_SUCCESS';
const REQUEST_SORTING_CAMPAIGN_FAILED = 'REQUEST_SORTING_CAMPAIGN_FAILED';

const REQUEST_UPDATE_STATUS_CONTACT_GROUP = 'REQUEST_UPDATE_STATUS_CONTACT_GROUP';
const REQUEST_UPDATE_STATUS_CONTACT_GROUP_SUCCESS = 'REQUEST_UPDATE_STATUS_CONTACT_GROUP_SUCCESS';
const REQUEST_UPDATE_STATUS_CONTACT_GROUP_FAILED = 'REQUEST_UPDATE_STATUS_CONTACT_GROUP_FAILED';

const TOGGLE_BACKGROUND_PROCESS = 'TOGGLE_BACKGROUND_PROCESS';

const REQUEST_SAVE_LAYOUT_MONITORING = 'REQUEST_SAVE_LAYOUT_MONITORING';
const REQUEST_SAVE_LAYOUT_MONITORING_SUCCESS = 'REQUEST_SAVE_LAYOUT_MONITORING_SUCCESS';
const REQUEST_SAVE_LAYOUT_MONITORING_FAILED = 'REQUEST_SAVE_LAYOUT_MONITORING_FAILED';

const REQUEST_SAVE_LAYOUT_CONTACT = 'REQUEST_SAVE_LAYOUT_CONTACT';
const REQUEST_SAVE_LAYOUT_CONTACT_SUCCESS = 'REQUEST_SAVE_LAYOUT_CONTACT_SUCCESS';
const REQUEST_SAVE_LAYOUT_CONTACT_FAILED = 'REQUEST_SAVE_LAYOUT_CONTACT_FAILED';

export default {
  REQUEST_SAVE_LAYOUT_CONTACT,
  REQUEST_SAVE_LAYOUT_CONTACT_SUCCESS,
  REQUEST_SAVE_LAYOUT_CONTACT_FAILED,

  REQUEST_SAVE_LAYOUT_MONITORING,
  REQUEST_SAVE_LAYOUT_MONITORING_SUCCESS,
  REQUEST_SAVE_LAYOUT_MONITORING_FAILED,

  TOGGLE_BACKGROUND_PROCESS,

  REQUEST_UPDATE_STATUS_CONTACT_GROUP,
  REQUEST_UPDATE_STATUS_CONTACT_GROUP_SUCCESS,
  REQUEST_UPDATE_STATUS_CONTACT_GROUP_FAILED,

  REQUEST_UPLOAD_ATTACHMENTS_CREATIVE,
  REQUEST_UPLOAD_ATTACHMENTS_CREATIVE_SUCCESS,
  REQUEST_UPLOAD_ATTACHMENTS_CREATIVE_FAILED,

  REQUEST_DELETE_ATTACHMENT,
  REQUEST_DELETE_ATTACHMENT_SUCCESS,
  REQUEST_DELETE_ATTACHMENT_FAILED,

  REQUEST_GET_MONITORING,
  REQUEST_GET_MONITORING_SUCCESS,
  REQUEST_GET_MONITORING_FAILED,

  REQUEST_SORTING_CAMPAIGN,
  REQUEST_SORTING_CAMPAIGN_SUCCESS,
  REQUEST_SORTING_CAMPAIGN_FAILED,

  REQUEST_SWITCH_STATUS_ROUTE_HISTORY,
  REQUEST_SWITCH_STATUS_ROUTE_HISTORY_SUCCESS,
  REQUEST_SWITCH_STATUS_ROUTE_HISTORY_FAILED,
  REQUEST_RESEND_TO_FAILED_CONTACTS,
  REQUEST_RESEND_TO_FAILED_CONTACTS_SUCCESS,
  REQUEST_RESEND_TO_FAILED_CONTACTS_FAILED,
  REQUEST_GET_BUYING_PROCESS,
  REQUEST_GET_BUYING_PROCESS_SUCCESS,
  REQUEST_GET_BUYING_PROCESS_FAILED,
  REQUEST_RELEASE_DOMAIN_SELECTED,
  REQUEST_RELEASE_DOMAIN_SELECTED_SUCCESS,
  REQUEST_RELEASE_DOMAIN_SELECTED_FAILED,
  REQUEST_REFRESH_CAMPAIGN,
  REQUEST_REFRESH_CAMPAIGN_SUCCESS,
  REQUEST_REFRESH_CAMPAIGN_FAILED,
  REQUEST_SET_LEAD_CALLBACK_LINK,
  REQUEST_SET_LEAD_CALLBACK_LINK_SUCCESS,
  REQUEST_SET_LEAD_CALLBACK_LINK_FAILED,
  REQUEST_RELEASE_DID_BY_CLICK_RATE,
  REQUEST_RELEASE_DID_BY_CLICK_RATE_SUCCESS,
  REQUEST_RELEASE_DID_BY_CLICK_RATE_FAILED,
  REQUEST_SAVE_LEAD_FILTER,
  REQUEST_SAVE_LEAD_FILTER_SUCCESS,
  REQUEST_SAVE_LEAD_FILTER_FAILED,
  REQUEST_CREATE_ORDER,
  REQUEST_CREATE_ORDER_FAILED,
  REQUEST_CREATE_ORDER_SUCCESS,
  REQUEST_CHECK_CREDIT,
  REQUEST_CHECK_CREDIT_SUCCESS,
  REQUEST_CHECK_CREDIT_FAILED,
  REQUEST_GET_LIST_ORDER,
  REQUEST_GET_LIST_ORDER_SUCCESS,
  REQUEST_GET_LIST_ORDER_FAILED,
  REQUEST_GET_CAMPAIGN_STATS,
  REQUEST_GET_CAMPAIGN_STATS_SUCCESS,
  REQUEST_GET_CAMPAIGN_STATS_FAILED,
  REQUEST_RELEASE_DOMAIN_NOW,
  REQUEST_RELEASE_DOMAIN_NOW_SUCCESS,
  REQUEST_RELEASE_DOMAIN_NOW_FAILED,
  REQUEST_GET_TOTAL_DID_IN_ACCOUNT,
  REQUEST_GET_TOTAL_DID_IN_ACCOUNT_SUCCESS,
  REQUEST_GET_TOTAL_DID_IN_ACCOUNT_FAILED,
  REQUEST_REFETCH_CONTACTS,
  REQUEST_CHECK_IMPORTING,
  REQUEST_CHECK_IMPORTING_SUCCESS,
  REQUEST_CHECK_IMPORTING_FAILED,
  REQUEST_CHECK_IMPORTING_CANCELED,
  REQUEST_CHECK_SCRUBBING,
  REQUEST_CHECK_SCRUBBING_SUCCESS,
  REQUEST_CHECK_SCRUBBING_FAILED,
  REQUEST_CHECK_SCRUBBING_CANCELED,
  REQUEST_LOAD_MORE_CAMPAIGN_IN_DOMAIN,
  REQUEST_GET_RESPONDER_IN_DOMAIN,
  REQUEST_GET_RESPONDER_IN_DOMAIN_SUCCESS,
  REQUEST_GET_RESPONDER_IN_DOMAIN_FAILED,
  REQUEST_GET_CAMPAIGN_IN_DOMAIN,
  REQUEST_GET_CAMPAIGN_IN_DOMAIN_SUCCESS,
  REQUEST_GET_CAMPAIGN_IN_DOMAIN_FAILED,
  REQUEST_UPDATE_REQUEST_CLICK,
  REQUEST_UPDATE_REQUEST_CLICK_SUCCESS,
  REQUEST_UPDATE_REQUEST_CLICK_FAILED,
  REQUEST_GET_HIGHLIGHT_HIST,
  REQUEST_GET_HIGHLIGHT_HIST_SUCCESS,
  REQUEST_GET_HIGHLIGHT_HIST_FAILED,
  REQUEST_STATS_BY_TIME,
  REQUEST_STATS_BY_TIME_SUCCESS,
  REQUEST_STATS_BY_TIME_FAILED,
  REQUEST_CREATE_TICKET,
  REQUEST_CREATE_TICKET_SUCCESS,
  REQUEST_CREATE_TICKET_FAILED,
  REQUEST_EDIT_TICKET,
  REQUEST_EDIT_TICKET_SUCCESS,
  REQUEST_EDIT_TICKET_FAILED,
  REQUEST_DELETE_COMMENT_TICKET,
  REQUEST_DELETE_COMMENT_TICKET_SUCCESS,
  REQUEST_DELETE_COMMENT_TICKET_FAILED,
  REQUEST_EDIT_COMMENT_TICKET,
  REQUEST_EDIT_COMMENT_TICKET_SUCCESS,
  REQUEST_EDIT_COMMENT_TICKET_FAILED,
  REQUEST_ADD_COMMENT_TICKET,
  REQUEST_ADD_COMMENT_TICKET_SUCCESS,
  REQUEST_ADD_COMMENT_TICKET_FAILED,
  REQUEST_GET_TICKET_BY_ID,
  REQUEST_GET_TICKET_BY_ID_SUCCESS,
  REQUEST_GET_TICKET_BY_ID_FAILED,
  REQUEST_DELETE_TICKET,
  REQUEST_DELETE_TICKET_SUCCESS,
  REQUEST_DELETE_TICKET_FAILED,
  REQUEST_GET_LIST_TICKETS,
  REQUEST_GET_LIST_TICKETS_SUCCESS,
  REQUEST_GET_LIST_TICKETS_FAILED,
  REQUEST_GET_DATA_CONSUMING,
  REQUEST_GET_DATA_CONSUMING_SUCCESS,
  REQUEST_GET_DATA_CONSUMING_FAILED,
  REQUEST_START_DATA_CONSUMING,
  REQUEST_START_DATA_CONSUMING_SUCCESS,
  REQUEST_START_DATA_CONSUMING_FAILED,
  REQUEST_GET_DATA_REFRESHING,
  REQUEST_GET_DATA_REFRESHING_FAILED,
  REQUEST_GET_DATA_REFRESHING_SUCCESS,
  REQUEST_START_DATA_REFRESHING,
  REQUEST_START_DATA_REFRESHING_FAILED,
  REQUEST_START_DATA_REFRESHING_SUCCESS,
  REQUEST_MARK_AS_ALL_READ,
  REQUEST_MARK_AS_ALL_READ_SUCCESS,
  REQUEST_MARK_AS_ALL_READ_FAILED,
  REQUEST_RE_FETCH_NOTIFICATION,
  REQUEST_RE_FETCH_NOTIFICATION_SUCCESS,
  REQUEST_RE_FETCH_NOTIFICATION_FAILED,
  REQUEST_LOAD_MORE_NOTIFICATION,
  REQUEST_LOAD_MORE_NOTIFICATION_SUCCESS,
  REQUEST_LOAD_MORE_NOTIFICATION_FAILED,
  REQUEST_COUNT_NOTIFICATION_SUCCESS,
  REQUEST_COUNT_NOTIFICATION_FAILED,
  REQUEST_DELETE_GUIDE,
  REQUEST_DELETE_GUIDE_SUCCESS,
  REQUEST_DELETE_GUIDE_FAILED,
  REQUEST_REORDER_GUIDE,
  REQUEST_REORDER_GUIDE_FAILED,
  REQUEST_REORDER_GUIDE_SUCCESS,
  REQUEST_GET_GUIDE,
  REQUEST_GET_GUIDE_SUCCESS,
  REQUEST_GET_GUIDE_FAILED,
  REQUEST_GET_GUIDE_BY_ROLE,
  REQUEST_GET_GUIDE_BY_ROLE_SUCCESS,
  REQUEST_GET_GUIDE_BY_ROLE_FAILED,
  REQUEST_SAVE_GUIDE,
  REQUEST_SAVE_GUIDE_SUCCESS,
  REQUEST_SAVE_GUIDE_FAILED,
  REQUEST_LOAD_MORE_ALL_DOMAIN,
  REQUEST_LOAD_MORE_ALL_DOMAIN_SUCCESS,
  REQUEST_LOAD_MORE_ALL_DOMAIN_FAILED,
  REQUEST_LOAD_MORE_DIDS_GROUP,
  REQUEST_LOAD_MORE_DIDS_GROUP_SUCCESS,
  REQUEST_LOAD_MORE_DIDS_GROUP_FAILED,
  CLEAR_INFO_CONTACT,
  REQUEST_SEARCH_DOMAIN_CANCEL,
  REQUEST_SEARCH_DOMAIN_CANCELLED,
  REQUEST_RELEASE_DID_NOW,
  REQUEST_RELEASE_DID_NOW_FAILED,
  REQUEST_RELEASE_DID_NOW_SUCCESS,
  REQUEST_SAVE_DID,
  REQUEST_SAVE_DID_SUCCESS,
  REQUEST_SAVE_DID_FAILED,
  REQUEST_REFETCH_RESPONDER_SUCCESS,
  REQUEST_REFETCH_RESPONDER_FAILED,
  REQUEST_FILTER_RESPONDER,
  REQUEST_FILTER_RESPONDER_SUCCESS,
  REQUEST_FILTER_RESPONDER_FAILED,
  REQUEST_LOAD_MORE_RESPONDER,
  REQUEST_LOAD_MORE_RESPONDER_FAILED,
  REQUEST_LOAD_MORE_RESPONDER_SUCCESS,
  REQUEST_LOAD_MORE_CONTACT,
  REQUEST_LOAD_MORE_CONTACT_SUCCESS,
  REQUEST_LOAD_MORE_CONTACT_FAILED,
  CHANGE_TYPE_CONTACT,
  REQUEST_CHANGE_NAME_CONTACT,
  REQUEST_CHANGE_NAME_CONTACT_SUCCESS,
  REQUEST_CHANGE_NAME_CONTACT_FAILED,
  REQUEST_MOVE_DID_SELECTED,
  REQUEST_MOVE_DID_SELECTED_SUCCESS,
  REQUEST_MOVE_DID_SELECTED_FAILED,
  REQUEST_SEARCH_CONTACT_SERVLET,
  REQUEST_SEARCH_CONTACT_SERVLET_SUCCESS,
  REQUEST_SEARCH_CONTACT_SERVLET_FAILED,
  REQUEST_REGENERATE_API_KEY,
  REQUEST_REGENERATE_API_KEY_SUCCESS,
  REQUEST_REGENERATE_API_KEY_FAILED,
  UPDATE_INBOX_DETAIL,
  REQUEST_SET_DID_GROUP_RESPONDER,
  REQUEST_SET_DID_GROUP_RESPONDER_SUCCESS,
  REQUEST_SET_DID_GROUP_RESPONDER_FAILED,
  CHANGE_THEME,
  REQUEST_DELETE_SINGLE_DID,
  REQUEST_DELETE_SINGLE_DID_SUCCESS,
  REQUEST_DELETE_SINGLE_DID_FAILED,
  REQUEST_UPDATE_DOMAIN_CAMPAIGN,
  REQUEST_UPDATE_DOMAIN_CAMPAIGN_SUCCESS,
  REQUEST_UPDATE_DOMAIN_CAMPAIGN_FAILED,
  REQUEST_LOAD_DOMAINS_IN_GROUP,
  REQUEST_LOAD_DOMAINS_IN_GROUP_SUCCESS,
  REQUEST_LOAD_DOMAINS_IN_GROUP_FAILED,
  REQUEST_RESET_DOMAIN_IN_GROUP,
  REQUEST_MIGRATE_DOMAIN_GROUP,
  REQUEST_MIGRATE_DOMAIN_GROUP_SUCCESS,
  REQUEST_MIGRATE_DOMAIN_GROUP_FAILED,
  REQUEST_DELETE_DOMAIN_GROUP,
  REQUEST_DELETE_DOMAIN_GROUP_SUCCESS,
  REQUEST_DELETE_DOMAIN_GROUP_FAILED,
  REQUEST_GET_ALL_DOMAIN_GROUP,
  REQUEST_GET_ALL_DOMAIN_GROUP_FAILED,
  REQUEST_GET_ALL_DOMAIN_GROUP_SUCCESS,
  REQUEST_CREATE_DOMAIN_GROUP,
  REQUEST_CREATE_DOMAIN_GROUP_FAILED,
  REQUEST_CREATE_DOMAIN_GROUP_SUCCESS,
  REQUEST_SAVE_DOMAIN_GROUP_SETTING,
  REQUEST_SAVE_DOMAIN_GROUP_SETTING_SUCCESS,
  REQUEST_SAVE_DOMAIN_GROUP_SETTING_FAILED,
  REQUEST_GET_LIST_DIALOG_TEMPLATE,
  REQUEST_GET_LIST_DIALOG_TEMPLATE_FAILED,
  REQUEST_GET_LIST_DIALOG_TEMPLATE_SUCCESS,
  CHANGE_FILTER_NOTIFICATION,
  REQUEST_GET_MORE_NOTIFICATION_SUCCESS,
  REQUEST_GET_NOTIFICATION,
  REQUEST_GET_NOTIFICATION_FAILED,
  REQUEST_GET_NOTIFICATION_SUCCESS,
  REQUEST_UPDATE_NOTIFICATION,
  REQUEST_UPDATE_NOTIFICATION_SUCCESS,
  REQUEST_UPDATE_NOTIFICATION_FAILED,
  UPDATE_CAMPAIGN,
  REQUEST_UPDATE_OFFER_CAMPAIGN,
  REQUEST_UPDATE_OFFER_CAMPAIGN_FAILED,
  REQUEST_UPDATE_OFFER_CAMPAIGN_SUCCESS,
  REQUEST_UPDATE_CREATIVE_CAMPAIGN,
  REQUEST_UPDATE_CREATIVE_CAMPAIGN_FAILED,
  REQUEST_UPDATE_CREATIVE_CAMPAIGN_SUCCESS,
  REQUEST_GET_CREATIVE_BY_CAMPAIGN_ID,
  REQUEST_GET_CREATIVE_BY_CAMPAIGN_ID_FAILED,
  REQUEST_GET_CREATIVE_BY_CAMPAIGN_ID_SUCCESS,
  REQUEST_FILTER_CREATIVE,
  REQUEST_FILTER_CREATIVE_FAILED,
  REQUEST_FILTER_CREATIVE_SUCCESS,
  REQUEST_UPDATE_CREATIVE,
  REQUEST_UPDATE_CREATIVE_FAILED,
  REQUEST_UPDATE_CREATIVE_SUCCESS,
  REQUEST_DELETE_CREATIVE,
  REQUEST_DELETE_CREATIVE_FAILED,
  REQUEST_DELETE_CREATIVE_SUCCESS,
  REQUEST_GET_LIST_CREATIVE,
  REQUEST_GET_LIST_CREATIVE_FAILED,
  REQUEST_GET_LIST_CREATIVE_SUCCESS,
  REQUEST_FILTER_OFFERS,
  REQUEST_FILTER_OFFERS_FAILED,
  REQUEST_FILTER_OFFERS_SUCCESS,
  REQUEST_CREATE_OFFER,
  REQUEST_CREATE_OFFER_FAILED,
  REQUEST_CREATE_OFFER_SUCCESS,
  REQUEST_GET_LIST_OFFER,
  REQUEST_GET_LIST_OFFER_FAILED,
  REQUEST_GET_LIST_OFFER_SUCCESS,
  REQUEST_UPDATE_OFFER,
  REQUEST_UPDATE_OFFER_SUCCESS,
  REQUEST_UPDATE_OFFER_FAILED,
  REQUEST_GET_OFFER_BY_ID,
  REQUEST_GET_OFFER_BY_ID_SUCCESS,
  REQUEST_GET_OFFER_BY_ID_FAILED,
  REQUEST_DELETE_OFFER,
  REQUEST_DELETE_OFFER_FAILED,
  REQUEST_DELETE_OFFER_SUCCESS,
  REQUEST_CREATE_CREATIVE,
  REQUEST_CREATE_CREATIVE_FAILED,
  REQUEST_CREATE_CREATIVE_SUCCESS,
  REQUEST_GET_CREATIVE_BY_ID,
  REQUEST_GET_CREATIVE_BY_ID_FAILED,
  REQUEST_GET_CREATIVE_BY_ID_SUCCESS,
  REQUEST_PHONE_NUMBERS,
  REQUEST_PHONE_NUMBERS_SUCCESS,
  REQUEST_PHONE_NUMBERS_FAILED,
  REQUEST_FILTER_CAMPAIGN,
  REQUEST_FILTER_CAMPAIGN_FAILED,
  REQUEST_FILTER_CAMPAIGN_SUCCESS,
  CHANGE_FILTER_CREATIVE,
  CHANGE_FILTER_OFFERS,
  CHANGE_FILTER_CAMPAIGN,
  REQUEST_CHECK_PURCHASE_ALL_GROUP,
  REQUEST_CHECK_PURCHASE_ALL_GROUP_SUCCESS,
  REQUEST_CHECK_PURCHASE_ALL_GROUP_FAILED,
  REQUEST_GET_PURCHASE_PROCESS,
  REQUEST_GET_PURCHASE_PROCESS_FAILED,
  REQUEST_GET_PURCHASE_PROCESS_SUCCESS,
  REQUEST_MESSAGE_STATS,
  REQUEST_MESSAGE_STATS_FAILED,
  REQUEST_MESSAGE_STATS_SUCCESS,
  REQUEST_SETUP_DOMAIN,
  REQUEST_SETUP_DOMAIN_SUCCESS,
  REQUEST_SETUP_DOMAIN_FAILED,
  REQUEST_CLEAR_DATA_SEARCH_DOMAIN,
  REQUEST_UPDATE_ALL_DOMAIN,
  REQUEST_UPDATE_ALL_DOMAIN_SUCCESS,
  REQUEST_UPDATE_ALL_DOMAIN_FAILED,
  REQUEST_BUY_DOMAIN,
  REQUEST_BUY_DOMAIN_SUCCESS,
  REQUEST_BUY_DOMAIN_FAILED,
  REQUEST_SEARCH_DOMAIN,
  REQUEST_SEARCH_DOMAIN_FAILED,
  REQUEST_SEARCH_DOMAIN_SUCCESS,
  REQUEST_DELETE_DOMAIN,
  REQUEST_DELETE_DOMAIN_SUCCESS,
  REQUEST_DELETE_DOMAIN_FAILED,
  REQUEST_ADD_DOMAIN,
  REQUEST_ADD_DOMAIN_FAILED,
  REQUEST_ADD_DOMAIN_SUCCESS,
  REQUEST_UPDATE_DOMAIN,
  REQUEST_UPDATE_DOMAIN_FAILED,
  REQUEST_UPDATE_DOMAIN_SUCCESS,
  REQUEST_GET_DOMAIN,
  REQUEST_GET_DOMAIN_FAILED,
  REQUEST_GET_DOMAIN_SUCCESS,
  REQUEST_GET_MORE_HISTORY_CHARGE,
  REQUEST_GET_MORE_HISTORY_CHARGE_FAILED,
  REQUEST_GET_MORE_HISTORY_CHARGE_SUCCESS,
  CLEAR_DID_KEYWORDS,
  REQUEST_SEARCH_DID,
  REQUEST_SEARCH_DID_FAILED,
  REQUEST_SEARCH_DID_SUCCESS,
  REQUEST_SPLIT_GROUPS,
  REQUEST_SPLIT_GROUPS_FAILED,
  REQUEST_SPLIT_GROUPS_SUCCESS,
  REQUEST_MERGE_GROUPS,
  REQUEST_MERGE_GROUPS_FAILED,
  REQUEST_MERGE_GROUPS_SUCCESS,
  REQUEST_LIST_PACKAGE,
  REQUEST_LIST_PACKAGE_FAILED,
  REQUEST_LIST_PACKAGE_SUCCESS,
  REQUEST_PURCHASE,
  REQUEST_PURCHASE_SUCCESS,
  REQUEST_PURCHASE_FAILED,
  REQUEST_SET_AUTO_RECHARGE,
  REQUEST_SET_AUTO_RECHARGE_FAILED,
  REQUEST_SET_AUTO_RECHARGE_SUCCESS,
  REQUEST_GET_LIST_HISTORY_CHARGE,
  REQUEST_GET_LIST_HISTORY_CHARGE_FAILED,
  REQUEST_GET_LIST_HISTORY_CHARGE_SUCCESS,
  REQUEST_DELETE_CARD,
  REQUEST_DELETE_CARD_FAILED,
  REQUEST_DELETE_CARD_SUCCESS,
  REQUEST_MAKE_DEFAULT,
  REQUEST_MAKE_DEFAULT_FAILED,
  REQUEST_MAKE_DEFAULT_SUCCESS,
  REQUEST_LIST_CARD,
  REQUEST_LIST_CARD_FAILED,
  REQUEST_LIST_CARD_SUCCESS,
  RESET_FORM_CARD,
  REQUEST_PAYMENT_SELECTED,
  REQUEST_ADD_CARD_METHOD,
  REQUEST_ADD_CARD_METHOD_SUCCESS,
  REQUEST_ADD_CARD_METHOD_FAILED,
  REQUEST_EXPORT_CAMPAIN,
  REQUEST_EXPORT_CAMPAIN_FAILED,
  REQUEST_EXPORT_CAMPAIN_SUCCESS,
  REQUEST_EXPORT_CREDIT_STATUS,
  REQUEST_EXPORT_CREDIT_STATUS_FAILED,
  REQUEST_EXPORT_CREDIT_STATUS_SUCCESS,
  REQUEST_EXPORT_USER,
  REQUEST_EXPORT_USER_SUCCESS,
  REQUEST_EXPORT_USER_FAILED,
  REQUEST_ROUTE_LIST,
  REQUEST_ROUTE_LIST_SUCCESS,
  REQUEST_ROUTE_LIST_FAILED,
  REQUEST_MOVE_DID,
  REQUEST_MOVE_DID_SUCCESS,
  REQUEST_MOVE_DID_FAILED,
  REQUEST_CLEAR_DID_DETAIL,
  REQUEST_ADD_DID_GROUP,
  REQUEST_ADD_DID_GROUP_SUCCESS,
  REQUEST_ADD_DID_GROUP_FAILED,
  REQUEST_BULK_PURCHASE,
  REQUEST_BULK_PURCHASE_FAILED,
  REQUEST_BULK_PURCHASE_SUCCESS,
  REQUEST_DELETE_DID,
  REQUEST_DELETE_DID_FAILED,
  REQUEST_DELETE_DID_SUCCESS,
  REQUEST_DID_DETAIL,
  REQUEST_DID_DETAIL_SUCCESS,
  REQUEST_DID_DETAIL_FAILED,
  REQUEST_LIST_DIDS,
  REQUEST_LIST_DIDS_SUCCESS,
  REQUEST_LIST_DIDS_FAILED,
  REQUEST_GET_STATS,
  REQUEST_GET_STATS_FAILED,
  REQUEST_GET_STATS_SUCCESS,
  REQUEST_RESTORE,
  REQUEST_RESTORE_SUCCESS,
  REQUEST_RESTORE_FAILED,
  REQUEST_BACKUP_NOW,
  REQUEST_BACKUP_NOW_SUCCESS,
  REQUEST_BACKUP_NOW_FAILED,
  REQUEST_UPDATE_SETTING_API,
  REQUEST_UPDATE_SETTING_API_SUCCESS,
  REQUEST_UPDATE_SETTING_API_FAILED,
  REQUEST_UPDATE_SETTING,
  REQUEST_UPDATE_SETTING_FAILED,
  REQUEST_UPDATE_SETTING_SUCCESS,
  REQUEST_GET_TABLE_PRICE,
  REQUEST_GET_TABLE_PRICE_SUCCESS,
  REQUEST_GET_TABLE_PRICE_FAILED,
  REQUEST_UPDATE_PROFILE,
  REQUEST_UPDATE_PROFILE_FAILED,
  REQUEST_UPDATE_PROFILE_SUCCESS,
  REQUEST_CLONE_USER,
  REQUEST_CLONE_USER_SUCCESS,
  REQUEST_CLONE_USER_FAILED,
  REQUEST_UPDATE_USER,
  REQUEST_UPDATE_USER_SUCCESS,
  REQUEST_UPDATE_USER_FAILED,
  REQUEST_ADD_CREDITS_USER,
  REQUEST_ADD_CREDITS_USER_SUCCESS,
  REQUEST_ADD_CREDITS_USER_FAILED,
  CLEAR_SHOW_DIDS,
  REQUEST_DELETE_VIRTUALPHONE,
  REQUEST_DELETE_VIRTUALPHONE_SUCCESS,
  REQUEST_DELETE_VIRTUALPHONE_FAILED,
  REQUEST_MIGRATE_DIDS,
  REQUEST_MIGRATE_DIDS_SUCCESS,
  REQUEST_MIGRATE_DIDS_FAILED,
  REQUEST_ADD_DIDS,
  REQUEST_ADD_DIDS_FAILED,
  REQUEST_ADD_DIDS_SUCCESS,
  REQUEST_SHOW_DIDS,
  REQUEST_SHOW_DIDS_SUCCESS,
  REQUEST_SHOW_DIDS_FAILED,
  REQUEST_CREATE_USERS,
  REQUEST_CREATE_USERS_FAILED,
  REQUEST_CREATE_USERS_SUCCESS,
  REQUEST_DELETE_USERS,
  REQUEST_DELETE_USERS_SUCCESS,
  REQUEST_DELETE_USERS_FAILED,
  REQUEST_SEARCH_LIST_USERS,
  REQUEST_SEARCH_LIST_USERS_SUCCESS,
  REQUEST_SEARCH_LIST_USERS_FAILED,
  REQUEST_GET_LIST_USERS,
  REQUEST_GET_LIST_USERS_SUCCESS,
  REQUEST_GET_LIST_USERS_FAILED,
  REQUEST_DELETE_RESPONDER_CONTENT,
  REQUEST_DELETE_RESPONDER_CONTENT_SUCCESS,
  REQUEST_DELETE_RESPONDER_CONTENT_FAILED,
  REQUEST_SELECTED_NODE,
  CLEAR_SELECTED_NODE,
  REQUEST_SAVE_RESPONDER_CONTENT,
  REQUEST_SAVE_RESPONDER_CONTENT_SUCCESS,
  REQUEST_SAVE_RESPONDER_CONTENT_FAILED,
  REQUEST_UPLOAD_NODE,
  REQUEST_UPLOAD_NODE_SUCCESS,
  REQUEST_UPLOAD_NODE_FAILED,
  REQUEST_GET_RESPONDER_DETAIL,
  REQUEST_GET_RESPONDER_DETAIL_SUCCESS,
  REQUEST_GET_RESPONDER_DETAIL_FAILED,
  CLEAR_RESPONDER_DETAIL,
  REQUEST_ADD_RESPONDER,
  REQUEST_ADD_RESPONDER_SUCCESS,
  REQUEST_ADD_RESPONDER_FAILED,
  REQUEST_DELETE_RESPONDER,
  REQUEST_DELETE_RESPONDER_SUCCESS,
  REQUEST_DELETE_RESPONDER_FAILED,
  REQUEST_SWITCH_RESPONDER,
  REQUEST_SWITCH_RESPONDER_SUCCESS,
  REQUEST_SWITCH_RESPONDER_FAILED,
  REQUEST_GET_LIST_DIALOG,
  REQUEST_GET_LIST_DIALOG_SUCCESS,
  REQUEST_GET_LIST_DIALOG_FAILED,
  REQUEST_SAVE_DIALOG,
  REQUEST_SAVE_DIALOG_SUCCESS,
  REQUEST_SAVE_DIALOG_FAILED,
  REQUEST_DELETE_CONTACT_BY_CARRIER,
  REQUEST_DELETE_CONTACT_BY_CARRIER_SUCCESS,
  REQUEST_DELETE_CONTACT_BY_CARRIER_FAILED,
  REQUEST_GET_CARRIER,
  REQUEST_GET_CARRIER_FAILED,
  REQUEST_GET_CARRIER_SUCCESS,
  REQUEST_CLEAR_IMPORT_CONTACT,
  REQUEST_GET_PROCESS_ID_IMPORT,
  REQUEST_GET_PROCESS_ID_IMPORT_SUCCESS,
  REQUEST_GET_PROCESS_ID_IMPORT_FAILED,
  REQUEST_CANCEL_IMPORT,
  REQUEST_CANCEL_IMPORT_SUCCESS,
  REQUEST_CANCEL_IMPORT_FAILED,
  REQUEST_CHECK_STATUS_IMPORT,
  REQUEST_CHECK_STATUS_IMPORT_SUCCESS,
  REQUEST_CHECK_STATUS_IMPORT_FAILED,
  REQUEST_CHECK_CANCELLED_STATUS_IMPORT,
  REQUEST_UPLOAD_LIST_CONTACT,
  REQUEST_UPLOAD_LIST_CONTACT_SUCCESS,
  REQUEST_UPLOAD_LIST_CONTACT_FAILED,
  REQUEST_GET_PREVIEW_LINE,
  REQUEST_GET_PREVIEW_LINE_SUCCESS,
  REQUEST_GET_PREVIEW_LINE_FAILED,
  REQUEST_HEADER_FIELD,
  REQUEST_HEADER_FIELD_SUCCESS,
  REQUEST_HEADER_FIELD_FAILED,
  REQUEST_DELETE_FILE,
  REQUEST_DELETE_FILE_SUCCESS,
  REQUEST_DELETE_FILE_FAILED,
  REQUEST_IMPORT_FROM_STORAGE,
  REQUEST_IMPORT_FROM_STORAGE_SUCCESS,
  REQUEST_IMPORT_FROM_STORAGE_FAILED,
  REQUEST_IMPORT_LIST_CONTACT,
  REQUEST_IMPORT_LIST_CONTACT_SUCCESS,
  REQUEST_IMPORT_LIST_CONTACT_FAILED,
  REQUEST_CANCEL_LANDLINE,
  REQUEST_CANCEL_LANDLINE_SUCCESS,
  REQUEST_CANCEL_LANDLINE_FAILED,
  REQUEST_REMOVE_GROUP,
  REQUEST_REMOVE_GROUP_SUCCESS,
  REQUEST_REMOVE_GROUP_FAILED,
  REQUEST_LANDLINE_CHECK,
  REQUEST_LANDLINE_CHECK_FAILED,
  REQUEST_LANDLINE_CHECK_SUCCESS,
  REQUEST_GETALL_LANDLINE_CHECK,
  REQUEST_GETALL_LANDLINE_CHECK_SUCCESS,
  REQUEST_GETALL_LANDLINE_CHECK_FAILED,
  REQUEST_CHECK_SCRUB,
  REQUEST_CHECK_SCRUB_SUCCESS,
  REQUEST_CHECK_SCRUB_FAILED,
  REQUEST_CHECK_SCRUB_CANCEL,
  CLEAR_SCRUB_CONTACT,
  REQUEST_SCRUB_CONTACT,
  REQUEST_SCRUB_CONTACT_SUCCESS,
  REQUEST_SCRUB_CONTACT_FAILED,
  REQUEST_GET_EDIT_CONTACT,
  REQUEST_GET_EDIT_CONTACT_SUCCESS,
  REQUEST_GET_EDIT_CONTACT_FAILED,
  REQUEST_CLEAR_EDIT_CONTACT,
  REQUEST_UPDATE_MESSAGE_HIST,
  REQUEST_UPDATE_MESSAGE_HIST_SUCCESS,
  REQUEST_UPDATE_MESSAGE_HIST_FAILED,
  REQUEST_MARK_AS_COMPLETED,
  REQUEST_MARK_AS_COMPLETED_SUCCESS,
  REQUEST_MARK_AS_COMPLETED_FAILED,
  REQUEST_CONTINUE_HIST,
  REQUEST_CONTINUE_HIST_SUCCESS,
  REQUEST_CONTINUE_HIST_FAILED,
  REQUEST_CLEAR_CONTACT_DETAIL,
  REQUEST_REMOVE_CONTACT,
  REQUEST_REMOVE_CONTACT_SUCCESS,
  REQUEST_REMOVE_CONTACT_FAILED,
  REQUEST_ADD_CONTACT,
  REQUEST_ADD_CONTACT_SUCCESS,
  REQUEST_ADD_CONTACT_FAILED,
  REQUEST_PAUSE_LOAD_HISTORY,
  REQUEST_PAUSE_LOAD_HISTORY_SUCCESS,
  REQUEST_PAUSE_LOAD_HISTORY_FAILED,
  IS_LAST_HISTORY,
  REQUEST_MORE_HISTORY,
  REQUEST_MORE_HISTORY_SUCCESS,
  REQUEST_MORE_HISTORY_FAILED,
  REQUEST_HISTORY_BY_ID,
  REQUEST_HISTORY_BY_ID_SUCCESS,
  REQUEST_HISTORY_BY_ID_FAILED,
  REQUEST_LOAD_CONFIG,
  REQUEST_LOAD_CONFIG_SUCCESS,
  REQUEST_LOAD_CONFIG_FAILED,
  REQUEST_MANAGE_USER,
  REQUEST_MANAGE_USER_SUCCESS,
  REQUEST_MANAGE_USER_FAILED,
  REQUEST_CHANGE_USER,
  REQUEST_CHANGE_USER_SUCCESS,
  REQUEST_CHANGE_USER_FAILED,
  REQUEST_AVAILABLE_COUNTRIES,
  REQUEST_AVAILABLE_COUNTRIES_SUCCESS,
  REQUEST_AVAILABLE_COUNTRIES_FAILED,
  REQUEST_PREVIEW_SPIN,
  REQUEST_PREVIEW_SPIN_SUCCESS,
  REQUEST_PREVIEW_SPIN_FAILED,
  REQUEST_CLEAR_PREVIEW_SPIN,
  REQUEST_CLEAR_SPIN,
  REQUEST_SPIN_SERVLET,
  REQUEST_SPIN_SERVLET_SUCCESS,
  REQUEST_SPIN_SERVLET_FAILED,
  REQUEST_SEND_SERVLET,
  REQUEST_SEND_SERVLET_SUCCESS,
  REQUEST_SEND_SERVLET_FAILED,
  REQUEST_SEND_INBOX_SERVLET,
  REQUEST_SEND_INBOX_SERVLET_SUCCESS,
  REQUEST_SEND_INBOX_SERVLET_FAILED,
  REQUEST_API_LOGIN,
  REQUEST_API_LOGIN_SUCCESS,
  REQUEST_API_LOGIN_FAILED,
  REQUEST_API_LOGOUT,
  REQUEST_API_LOGOUT_SUCCESS,
  REQUEST_API_BALANCE,
  REQUEST_API_BALANCE_FAILED,
  REQUEST_API_BALANCE_SUCCESS,
  REQUEST_CLEAR_BALANCE,
  REQUEST_API_USERSERVLET,
  REQUEST_API_USERSERVLET_FAILED,
  REQUEST_API_USERSERVLET_SUCCESS,
  REQUEST_CLEAR_USERSERVLET,
  REQUEST_API_CONTACT_SERVLET,
  REQUEST_API_MANAGE_CONTACT_SERVLET,
  REQUEST_API_MANAGE_CONTACT_SERVLET_SUCCESS,
  REQUEST_API_CONTACT_SERVLET_SUCCESS,
  REQUEST_API_CONTACT_SERVLET_FAILED,
  REQUEST_CLEAR_CONTACT_SERVLET,
  REQUEST_CLEAR_CONTACT_SERVLET_SUCCESS,
  REQUEST_API_AUTO_REPLIES_SERVLET,
  REQUEST_API_AUTO_REPLIES_SERVLET_SUCCESS,
  REQUEST_API_AUTO_REPLIES_SERVLET_FAILED,
  REQUEST_CLEAR_AUTO_REPLIES_SERVLET,
  REQUEST_CLEAR_AUTO_REPLIES_SERVLET_SUCCESS,
  REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS,
  REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_SUCCESS,
  REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_FAILED,
  REQUEST_API_SERVLET,
  REQUEST_API_SERVLET_SUCCESS,
  REQUEST_API_SERVLET_FAILED,
  REQUEST_REFRESH_SERVLET,
  REQUEST_CLEAR_SERVLET,
  REQUEST_API_INBOX,
  REQUEST_API_INBOX_LOADMORE,
  REQUEST_API_INBOX_SUCCESS,
  REQUEST_API_INBOX_FAILED,
  REQUEST_CLEAR_INBOX,
  REQUEST_API_INBOX_LOADMORE_SUCCESS,
  REQUEST_API_INBOX_DETAIL,
  REQUEST_API_INBOX_DETAIL_SUCCESS,
  REQUEST_API_INBOX_CHANGE_STAR,
  REQUEST_API_INBOX_CHANGE_STAR_SUCCESS,
  REQUEST_API_GET_CONTACT_BELONG_TO,
  REQUEST_API_GET_CONTACT_BELONG_TO_SUCCESS,
  REQUEST_API_INBOX_FILTER_SUCCESS,
  REQUEST_API_INBOX_FILTER,
  REQUEST_API_EXPORT_INBOX_SUCCESS,
  REQUEST_API_EXPORT_INBOX,
  REQUEST_CLEAR_EXPORT_INBOX,
  REQUEST_API_DELETE,
  REQUEST_API_DELETE_SUCCESS,
  REQUEST_API_DELETE_ALL,
  REQUEST_API_DELETE_ALL_SUCCESS,
  REQUEST_CLEAR_DETAIL_INBOX,
  REQUEST_INBOX_BETA,
  REQUEST_API_DELETE_BY_DATE,
  REQUEST_API_DELETE_BY_DATE_SUCCESS,
  REQUEST_PULL_REVENUE_CAMPAIGN,
  REQUEST_PULL_REVENUE_CAMPAIGN_SUCCESS,
  REQUEST_PULL_REVENUE_CAMPAIGN_FAILED,
};
